/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddPackageOrderView {
  packageId?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  isTermAccepted?: boolean;
}

export interface Address {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  addressLine1: string;
  city?: string | null;
  state?: string | null;
  country: string;
  postalCode?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  emailAddress?: string | null;
  phoneNumber?: string | null;
  addressLines?: string[] | null;
  completeAddress?: string | null;
  companies?: Company[] | null;
  users?: IdentityUser[] | null;
}

export interface AddressView {
  /** @format int64 */
  id?: number;
  addressLine1?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postalCode?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  emailAddress?: string | null;
  phoneNumber?: string | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
}

export interface AddressViewPaginationResult {
  items?: AddressView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface AdminLoginView {
  /** @format email */
  emailAddress?: string | null;
  password?: string | null;
}

export interface AdvisorAvailabilityHistoryView {
  /** @format int64 */
  rowId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  createdByUser?: IdentityUserView | null;
  lastModifiedByUser?: IdentityUserView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  rowInsertedDate?: string;
  /** @format int64 */
  advisorId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  validFrom?: string | null;
  /** @format date-time */
  expiryDate?: string | null;
  status?: AppointmentStatus;
  /** @format double */
  price?: number;
  priceNote?: string | null;
}

export interface AdvisorAvailabilityHistoryViewPaginationResult {
  items?: AdvisorAvailabilityHistoryView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface AdvisorAvailabilityImportDto {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number | null;
  advisorName?: string | null;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  createdDate?: string;
  importStatus?: AvailabilityImportStatus;
  /** @format date-time */
  lastImportDate?: string | null;
  lastImportErrorCode?: string | null;
  lastImportErrorLog?: string | null;
  /** @format int64 */
  importedAppointmentAvailabilityId?: number | null;
  /** @format int64 */
  availabilityFormParseResultId?: number;
}

export interface AdvisorAvailabilityImportDtoPaginationResult {
  items?: AdvisorAvailabilityImportDto[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum AdvisorAvailabilityImportWithImportStatus {
  WAITING = 'WAITING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  SKIP = 'SKIP',
}

export interface AdvisorProfileView {
  /** @format int64 */
  id?: number;
  email?: string | null;
  phoneNumber?: string | null;
  userName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  previousSessions?: AdvisorSessionView[] | null;
  futureSessions?: AdvisorSessionView[] | null;
}

export interface AdvisorSessionView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorName?: string | null;
  advisorEmail?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerName?: string | null;
  customerEmail?: string | null;
  companyName?: string | null;
  status?: BookingCalendarEventStatus;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  createdDate?: string;
}

export interface AminSendMailRequest {
  emailTemplateName: string;
  locale: string;
  emailData?: any;
  userIds: number[];
}

export interface AnonymousTokenValidationRequest {
  otpToken?: string | null;
  salt?: string | null;
  /** @format int64 */
  userId?: number | null;
  userEmail?: string | null;
}

export interface ApplicationSettingsView {
  /** @format int32 */
  expirationJobOffSetInMinutes?: number;
  /** @format int32 */
  bookingOnlinePaymentPrice?: number;
  bookingOnlinePaymentCurrency?: string | null;
  isUsingWisoryVideoPlatform?: boolean;
  isGenericCommentEnabled?: boolean;
  isAutoBuyFormEnabled?: boolean;
  /** @format int32 */
  instantMeetingUnusedRoomTimeoutByMinutes?: number;
}

export interface AppointmentAvailabilityDto {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorName?: string | null;
  advisorEmail?: string | null;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  status?: AppointmentStatus;
  /** @format date-time */
  validFrom?: string | null;
  /** @format date-time */
  expiryDate?: string | null;
  /** @format date-time */
  createdDate?: string;
  externalCalendarId?: string | null;
  /** @format double */
  price?: number;
  customerName?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerEmail?: string | null;
  locale?: string | null;
  /** @format int64 */
  bookingId?: number | null;
  advisorCompanyName?: string | null;
  customerCompanyName?: string | null;
}

export interface AppointmentAvailabilityDtoPaginationResult {
  items?: AppointmentAvailabilityDto[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum AppointmentStatus {
  AVAILABLE = 'AVAILABLE',
  RESERVED = 'RESERVED',
  BOOKED = 'BOOKED',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
}

export interface AssignAddressToCompanyView {
  isPrimaryAddress?: boolean;
}

export interface AssignUserToCompanyView {
  isMainContact?: boolean;
}

export interface AvailabilityFormParseResultDto {
  /** @format int64 */
  id?: number;
  rawFormJson?: string | null;
  parseErrors?: string[] | null;
  hasParsedError?: boolean;
  googleFormId?: string | null;
  googleFormTitle?: string | null;
  googleAppScriptTriggerUid?: string | null;
  /** @format date-time */
  createdDate?: string;
}

export interface AvailabilityFormParseResultDtoPaginationResult {
  items?: AvailabilityFormParseResultDto[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum AvailabilityImportStatus {
  PENDING = 'PENDING',
  IMPORTED = 'IMPORTED',
  NOT_IMPORTED = 'NOT_IMPORTED',
  UNAPPROVED = 'UNAPPROVED',
}

export interface BookingCalendarEventDetailInternalResponse {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorName?: string | null;
  advisorEmail?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerName?: string | null;
  customerFirstName?: string | null;
  customerEmail?: string | null;
  companyName?: string | null;
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format date-time */
  createdDate?: string;
  status?: BookingCalendarEventStatus;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  reason?: string | null;
  externalId?: string | null;
  invoice?: InvoiceView | null;
  /** @format int64 */
  invoiceId?: number | null;
  useOnlinePayment?: boolean;
  paymentType?: BookingPaymentType;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  lastSentAdvisorEmail?: string | null;
  locale?: string | null;
  /** @format double */
  price?: number;
  bookingCalendarEventType?: BookingCalendarEventType | null;
  canBeRebook?: boolean;
  canBeVerified?: boolean;
  /** @format int64 */
  originBookingId?: number | null;
  bookingQuality?: BookingQualityEnum;
  acceptTransitionStates?: BookingCalendarEventStatus[] | null;
  bookingCalendarEventTypeDisplayName?: string | null;
  acceptTransitionStatesName?: string | null;
  reference?: string | null;
  sessionDetailResponse?: WisoryVideoApiClientSessionDetailInternalResponse | null;
  wisoryVideoStatusResponse?: WisoryVideoApiClientGetWisoryVideoStatusResponse | null;
  videoLink?: string | null;
  backupVideoLink?: string | null;
  /** @format double */
  currentPriceOfStatus?: number | null;
  advisorFirstName?: string | null;
  advisorLastName?: string | null;
  customerLastName?: string | null;
  /** @format double */
  companyRemainCredit?: number | null;
  /** @format int64 */
  adjustmentValue?: number;
  isRefunded?: boolean;
  isStarted?: boolean;
  platformTypeDisplay?: string | null;
}

export interface BookingCalendarEventDetailResponse {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorName?: string | null;
  advisorEmail?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerName?: string | null;
  customerFirstName?: string | null;
  customerEmail?: string | null;
  companyName?: string | null;
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format date-time */
  createdDate?: string;
  status?: BookingCalendarEventStatus;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  reason?: string | null;
  externalId?: string | null;
  invoice?: InvoiceView | null;
  /** @format int64 */
  invoiceId?: number | null;
  useOnlinePayment?: boolean;
  paymentType?: BookingPaymentType;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  lastSentAdvisorEmail?: string | null;
  locale?: string | null;
  /** @format double */
  price?: number;
  bookingCalendarEventType?: BookingCalendarEventType | null;
  canBeRebook?: boolean;
  canBeVerified?: boolean;
  /** @format int64 */
  originBookingId?: number | null;
  bookingQuality?: BookingQualityEnum;
  acceptTransitionStates?: BookingCalendarEventStatus[] | null;
  bookingCalendarEventTypeDisplayName?: string | null;
  acceptTransitionStatesName?: string | null;
  reference?: string | null;
  sessionDetailResponse?: WisoryVideoApiClientSessionDetailInternalResponse | null;
  wisoryVideoStatusResponse?: WisoryVideoApiClientGetWisoryVideoStatusResponse | null;
  videoLink?: string | null;
  backupVideoLink?: string | null;
  /** @format double */
  currentPriceOfStatus?: number | null;
  advisorFirstName?: string | null;
  advisorLastName?: string | null;
  customerLastName?: string | null;
  /** @format double */
  companyRemainCredit?: number | null;
  /** @format int64 */
  adjustmentValue?: number;
  isRefunded?: boolean;
  isStarted?: boolean;
  /** @format uuid */
  interestRequestId?: string | null;
  interestRequestView?: WisoryPingPongApiClientInterestRequestView | null;
  createdBy?: IdentityUserView | null;
  wisoryVideoSessionDetail?: WisoryVideoApiClientSessionDetailInternalResponse | null;
}

export interface BookingCalendarEventDto {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorName?: string | null;
  advisorEmail?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerName?: string | null;
  customerFirstName?: string | null;
  customerEmail?: string | null;
  companyName?: string | null;
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format date-time */
  createdDate?: string;
  status?: BookingCalendarEventStatus;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  reason?: string | null;
  externalId?: string | null;
  invoice?: InvoiceView | null;
  /** @format int64 */
  invoiceId?: number | null;
  useOnlinePayment?: boolean;
  paymentType?: BookingPaymentType;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  lastSentAdvisorEmail?: string | null;
  locale?: string | null;
  /** @format double */
  price?: number;
  bookingCalendarEventType?: BookingCalendarEventType | null;
  canBeRebook?: boolean;
  canBeVerified?: boolean;
  /** @format int64 */
  originBookingId?: number | null;
  bookingQuality?: BookingQualityEnum;
  acceptTransitionStates?: BookingCalendarEventStatus[] | null;
  bookingCalendarEventTypeDisplayName?: string | null;
  acceptTransitionStatesName?: string | null;
  reference?: string | null;
  sessionDetailResponse?: WisoryVideoApiClientSessionDetailInternalResponse | null;
  wisoryVideoStatusResponse?: WisoryVideoApiClientGetWisoryVideoStatusResponse | null;
  videoLink?: string | null;
  backupVideoLink?: string | null;
  /** @format double */
  currentPriceOfStatus?: number | null;
  advisorFirstName?: string | null;
  advisorLastName?: string | null;
  customerLastName?: string | null;
  /** @format double */
  companyRemainCredit?: number | null;
  /** @format int64 */
  adjustmentValue?: number;
  isRefunded?: boolean;
}

export interface BookingCalendarEventDtoPaginationResult {
  items?: BookingCalendarEventDto[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface BookingCalendarEventHistoryView {
  /** @format int64 */
  rowId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  createdByUser?: IdentityUserView | null;
  lastModifiedByUser?: IdentityUserView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  rowInsertedDate?: string;
  /** @format int64 */
  advisorId?: number;
  /** @format int64 */
  customerId?: number | null;
  /** @format int64 */
  appointmentAvailabilityId?: number;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  status?: BookingCalendarEventStatus;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  externalId?: string | null;
  /** @format int64 */
  invoiceId?: number | null;
  paymentType?: BookingPaymentType;
  /** @format int64 */
  adjustmentValue?: number;
  isRefunded?: boolean;
}

export interface BookingCalendarEventHistoryViewPaginationResult {
  items?: BookingCalendarEventHistoryView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum BookingCalendarEventStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  INVOICED = 'INVOICED',
  PERFORMED = 'PERFORMED',
  LATE_CANCELLED = 'LATE_CANCELLED',
  NO_SHOW = 'NO_SHOW',
  USER_SENT_PROPOSAL = 'USER_SENT_PROPOSAL',
  ADVISOR_SENT_PROPOSAL = 'ADVISOR_SENT_PROPOSAL',
}

export interface BookingCalendarEventStatusResponse {
  bookingCalendarEventStatus?: BookingCalendarEventStatus;
  name?: string | null;
  /** @format int32 */
  value?: number;
}

export enum BookingCalendarEventType {
  Website = 'Website',
  BackOffice = 'BackOffice',
  Rebuy = 'Rebuy',
}

export interface BookingCalendarSessionLinkResponse {
  /** @format uuid */
  id?: string;
  /** @format int64 */
  bookingCalendarEventId?: number;
  platformType?: CalendarEventPlatformType;
  fullLink?: string | null;
  /** @format date-time */
  lastAccessed?: string;
}

export enum BookingCreditAdjustmentType {
  NONE = 'NONE',
  ADJUSTMENT = 'ADJUSTMENT',
  BOOKING = 'BOOKING',
  CANCELED = 'CANCELED',
  POSTPONED = 'POSTPONED',
  PRICE_UPDATE = 'PRICE_UPDATE',
}

export interface BookingEmailStatus {
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
  eventType?: EmailEventType | null;
  emailAddress?: string | null;
  emailAddressType?: EmailAddressType;
  emailType?: EmailTemplateNameEnum | null;
  /** @format date-time */
  eventDate?: string | null;
  /** @format int64 */
  bookingId?: number | null;
  isBookingEmail?: boolean;
  isBgEmail?: boolean;
}

export interface BookingEmailStatusPaginationResult {
  items?: BookingEmailStatus[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum BookingPaymentType {
  COMPANY_CREDIT = 'COMPANY_CREDIT',
  CARD_PAYMENT = 'CARD_PAYMENT',
  INVOICE = 'INVOICE',
}

export enum BookingQualityEnum {
  Untrack = 'Untrack',
  Valid = 'Valid',
  NeedsWork = 'NeedsWork',
}

export interface BookingSessionHistoryView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userBookingSessionHistoryId?: number | null;
  /** @format int64 */
  companyBookingSessionHistoryId?: number | null;
  /** @format int64 */
  calendarEventBookingSessionHistoryId?: number | null;
  userBookingSessionHistory?: UserBookingSessionHistoryView | null;
  companyBookingSessionHistory?: CompanyBookingSessionHistoryView | null;
  calendarEventBookingSessionHistory?: CalendarEventBookingSessionHistoryView | null;
  adjustmentType?: BookingCreditAdjustmentType | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  createdByUser?: IdentityUserView | null;
  lastModifiedByUser?: IdentityUserView | null;
}

export interface BookingSessionHistoryViewPaginationResult {
  items?: BookingSessionHistoryView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface CalendarEventBookingSessionHistoryView {
  /** @format int64 */
  bookingCalendarEventId?: number | null;
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
}

export interface CalendarEventCancellationView {
  canBeCancelled?: boolean;
  canCancelWithoutBeingCharged?: boolean | null;
  isLateCancelledEvent?: boolean;
}

export enum CalendarEventPlatformType {
  NONE = 'NONE',
  GOOGLE_MEET = 'GOOGLE_MEET',
  MS_TEAMS = 'MS_TEAMS',
  ZOOM = 'ZOOM',
  WISORY_VIDEO = 'WISORY_VIDEO',
  WISORY_VIDEO_NEXT = 'WISORY_VIDEO_NEXT',
}

export interface CalendarListEntry {
  accessRole?: string | null;
  backgroundColor?: string | null;
  colorId?: string | null;
  conferenceProperties?: ConferenceProperties | null;
  defaultReminders?: EventReminder[] | null;
  deleted?: boolean | null;
  description?: string | null;
  eTag?: string | null;
  foregroundColor?: string | null;
  hidden?: boolean | null;
  id?: string | null;
  kind?: string | null;
  location?: string | null;
  notificationSettings?: NotificationSettingsData | null;
  primary?: boolean | null;
  selected?: boolean | null;
  summary?: string | null;
  summaryOverride?: string | null;
  timeZone?: string | null;
}

export interface CalendarNotification {
  method?: string | null;
  type?: string | null;
  eTag?: string | null;
}

export interface CheckCalendarEventRebookView {
  canBeRebooked?: boolean;
  proposalTimeSlots?: string[] | null;
}

export interface CheckOverlappedSlot {
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format int64 */
  excludeBookingId?: number | null;
}

export enum ChecksumValidationStatus {
  NOT_VALIDATED = 'NOT_VALIDATED',
  PENDING_RESPONSE_READ = 'PENDING_RESPONSE_READ',
  SUCCESSFUL = 'SUCCESSFUL',
  INVALID = 'INVALID',
}

export interface CommentIdentityUserView {
  /** @format int64 */
  id?: number;
  email?: string | null;
  userName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface CommentView {
  /** @format uuid */
  id?: string;
  entityType?: string | null;
  entityId?: string | null;
  content?: string | null;
  /** @format uuid */
  replyToComment?: string | null;
  url?: string | null;
  createdBy?: CommentIdentityUserView | null;
  /** @format date-time */
  createdDate?: string;
}

export interface CommentViewPaginationResult {
  items?: CommentView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface Company {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  companyName: string;
  companyNumber: string;
  /** @format int64 */
  mainContactId?: number | null;
  mainContact?: IdentityUser | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  primaryAddress?: Address | null;
  users?: IdentityUser[] | null;
  /** @format double */
  bookingSessionCredit: number;
  /** @format int64 */
  companyBookingSessionHistoryId?: number | null;
}

export interface CompanyBookingSessionHistoryView {
  /** @format int64 */
  companyId?: number | null;
  companyName?: string | null;
  companyNumber?: string | null;
  /** @format double */
  bookingSessionCredit?: number | null;
}

export interface CompanyHistoryView {
  /** @format int64 */
  rowId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  createdByUser?: IdentityUserView | null;
  lastModifiedByUser?: IdentityUserView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  rowInsertedDate?: string;
  companyName?: string | null;
  companyNumber?: string | null;
  /** @format int64 */
  mainContactId?: number | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format double */
  bookingSessionCredit?: number | null;
  /** @format int64 */
  companyBookingSessionHistoryId?: number | null;
}

export interface CompanyHistoryViewPaginationResult {
  items?: CompanyHistoryView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface CompanyUserView {
  /** @format int64 */
  id?: number;
  email?: string | null;
  phoneNumber?: string | null;
  userName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  createdBy?: string | null;
  lastModifiedBy?: string | null;
  primaryAddress?: AddressView | null;
  description?: string | null;
  company?: CompanyView | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  companyId?: number | null;
  professionalTitle?: CustomerProfessionalTitle | null;
  status?: UserStatusEnum;
  roles?: string[] | null;
  metadataSets?: MetadataSetView[] | null;
  fullName?: string | null;
  hadPassword?: boolean;
  /** @format int32 */
  totalSessionCount?: number | null;
  /** @format int32 */
  nextSessionCount?: number | null;
  /** @format date-time */
  nextBookingSessionDate?: string | null;
  /** @format date-time */
  lastBookingSessionDate?: string | null;
  /** @format int32 */
  totalLateSessionCount?: number | null;
  /** @format int32 */
  totalPerformedSessionCount?: number | null;
  timeZoneId?: string | null;
  /** @format int32 */
  totalSessions?: number;
  /** @format int64 */
  lastBookingSessionId?: number;
}

export interface CompanyUserViewPaginationResult {
  items?: CompanyUserView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface CompanyView {
  /** @format int64 */
  id?: number;
  companyName?: string | null;
  companyNumber?: string | null;
  /** @format int64 */
  mainContactId?: number | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  createdByUserId?: number | null;
  mainContact?: IdentityUserView | null;
  primaryAddress?: AddressView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format double */
  bookingSessionCredit?: number | null;
}

export interface CompanyViewPaginationResult {
  items?: CompanyView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface ConferenceData {
  conferenceId?: string | null;
  conferenceSolution?: ConferenceSolution | null;
  createRequest?: CreateConferenceRequest | null;
  entryPoints?: EntryPoint[] | null;
  notes?: string | null;
  parameters?: ConferenceParameters | null;
  signature?: string | null;
  eTag?: string | null;
}

export interface ConferenceParameters {
  addOnParameters?: ConferenceParametersAddOnParameters | null;
  eTag?: string | null;
}

export interface ConferenceParametersAddOnParameters {
  parameters?: Record<string, string>;
  eTag?: string | null;
}

export interface ConferenceProperties {
  allowedConferenceSolutionTypes?: string[] | null;
  eTag?: string | null;
}

export interface ConferenceRequestStatus {
  statusCode?: string | null;
  eTag?: string | null;
}

export interface ConferenceSolution {
  iconUri?: string | null;
  key?: ConferenceSolutionKey | null;
  name?: string | null;
  eTag?: string | null;
}

export interface ConferenceSolutionKey {
  type?: string | null;
  eTag?: string | null;
}

export enum CoreChecksumAlgorithm {
  NONE = 'NONE',
  CRC32C = 'CRC32C',
  CRC32 = 'CRC32',
  SHA256 = 'SHA256',
  SHA1 = 'SHA1',
}

export interface CreateAddressView {
  country: string;
  city: string;
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  postalCode: string;
  state: string;
  addressLine1: string;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
}

export interface CreateAppointmentAvailabilityView {
  /** @format int64 */
  advisorId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  validFrom?: string | null;
  /** @format date-time */
  expiryDate?: string | null;
  locale?: string | null;
}

export interface CreateBookingCalendarEventOnlinePaymentView {
  bookingCalendarEventType?: BookingCalendarEventType;
  /** @format int64 */
  appointmentAvailabilityId?: number;
  customerInfo?: OnlinePaymentCustomerInfo | null;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  reference?: string | null;
  callbackSuccessUrl?: string | null;
  callbackCancelUrl?: string | null;
}

export interface CreateBookingCalendarEventViewFromBackOffice {
  bookingCalendarEventType?: BookingCalendarEventType;
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format int64 */
  advisorId?: number | null;
  /** @format int64 */
  customerId?: number;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  reason?: string | null;
  reference?: string | null;
  skipVerifyProcess?: boolean;
  locale?: string | null;
  whoBookType?: WhoBookType;
  /** @format int64 */
  bookingId?: number | null;
  isPingPongProcess?: boolean;
  isRescheduled?: boolean;
}

export interface CreateBookingInvoicePaymentView {
  /** @format int64 */
  appointmentAvailabilityId?: number;
  invoiceRecipientInfo?: InvoiceRecipientInfoView | null;
  platformType?: CalendarEventPlatformType;
  shortDescription?: string | null;
  reference?: string | null;
}

export interface CreateCommentRequest {
  url?: string | null;
  entityType?: string | null;
  entityId?: string | null;
  content?: string | null;
}

export interface CreateCommentResponse {
  commentView?: CommentView | null;
}

export interface CreateCompanyView {
  companyName: string;
  /** @format int64 */
  mainContactId?: number | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  bookingSessionCredit?: number;
}

export interface CreateConferenceRequest {
  conferenceSolutionKey?: ConferenceSolutionKey | null;
  requestId?: string | null;
  status?: ConferenceRequestStatus | null;
  eTag?: string | null;
}

export interface CreateExternalCalendarEventRequest {
  /** @format int64 */
  bookingId: number;
  force?: boolean;
}

export interface CreateMetadataSetOptionView {
  displayName: string;
  value: string;
}

export interface CreateMetadataSetView {
  name: string;
  description?: string | null;
  entityType: string;
  displayType: MetadataDisplayType;
  options?: CreateMetadataSetOptionView[] | null;
}

export interface CreateOrUpdateMetadataView {
  /** @format int64 */
  metadataSetId: number;
  value?: string | null;
}

export interface CreateOrUpdateUserMetadataView {
  value?: string | null;
}

export interface CreateShortLinkRequest {
  token?: string | null;
  fullUrl?: string | null;
  metadata?: string | null;
  dataKey?: string | null;
  /** @format date-time */
  expirationDate?: string;
}

export interface CreateShortLinkResponse {
  shortUrl?: string | null;
  /** @format uuid */
  shortLinkId?: string;
}

export interface CreateUserMetadataSetView {
  name: string;
  description?: string | null;
  displayType: MetadataDisplayType;
  options?: CreateMetadataSetOptionView[] | null;
}

export interface CreateUserView {
  firstName?: string | null;
  lastName?: string | null;
  /** @pattern ^[a-zA-Z0-9._]{6,}$ */
  userName: string;
  description?: string | null;
  emailAddress: string;
  /** @pattern ^\+[1-9][\s0-9]{0,25}$ */
  phoneNumber: string;
  password?: string | null;
  /** @format int64 */
  companyId?: number | null;
  isSendingOnboardingEmail?: boolean;
  professionalTitle?: CustomerProfessionalTitle | null;
  roles?: string[] | null;
}

export interface CreatorData {
  displayName?: string | null;
  email?: string | null;
  id?: string | null;
  self?: boolean | null;
}

export enum CustomerProfessionalTitle {
  Finance = 'Finance',
  Sales = 'Sales',
  Marketing = 'Marketing',
  HR = 'HR',
  CEO_GM = 'CEO_GM',
  ITTech = 'IT_Tech',
  Engineering = 'Engineering',
  Logistic = 'Logistic',
  SupplyChain = 'SupplyChain',
}

export enum EmailAddressType {
  NONE = 'NONE',
  TO = 'TO',
  CC = 'CC',
  BCC = 'BCC',
}

export enum EmailEventType {
  NONE = 'NONE',
  DELIVERED = 'DELIVERED',
  DROPPED = 'DROPPED',
  DEFERRED = 'DEFERRED',
  BOUNCE = 'BOUNCE',
  OPEN = 'OPEN',
}

export interface EmailPreviewByTemplateRequestView {
  enabledSendPreviewTestEmail?: boolean;
  sendPreviewToEmail?: string | null;
  /** @format int64 */
  emailTemplateId?: number;
  /** @format int64 */
  emailTemplateVersionId?: number | null;
}

export interface EmailPreviewRequestView {
  enabledSendPreviewTestEmail?: boolean;
  sendPreviewToEmail?: string | null;
  emailTemplateName?: string | null;
  locale?: string | null;
  previewEmailSubject?: string | null;
  previewEmailBody?: string | null;
}

export enum EmailTemplateContentType {
  NONE = 'NONE',
  RICH_TEXT = 'RICH_TEXT',
  GOOGLE_CALENDAR_PLAIN_TEXT = 'GOOGLE_CALENDAR_PLAIN_TEXT',
}

export enum EmailTemplateFormat {
  Scriban = 'Scriban',
  Plain = 'Plain',
  Mjml = 'Mjml',
  Razor = 'Razor',
}

export interface EmailTemplateHistoryView {
  /** @format int64 */
  rowId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  createdByUser?: IdentityUserView | null;
  lastModifiedByUser?: IdentityUserView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  rowInsertedDate?: string;
  /** @format int64 */
  historyId?: number;
  name?: string | null;
  description?: string | null;
  subject?: string | null;
  message?: string | null;
  locale?: string | null;
  contentType?: EmailTemplateContentType;
  /** @format int64 */
  version?: number;
}

export interface EmailTemplateHistoryViewPaginationResult {
  items?: EmailTemplateHistoryView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum EmailTemplateNameEnum {
  MAIL_TO_USER_USER_BOOKED_AVAILABLE_TIMESLOT = 'MAIL_TO_USER_USER_BOOKED_AVAILABLE_TIMESLOT',
  WISORY_PACKAGE_BOOKING_CONFIRMATION = 'WISORY_PACKAGE_BOOKING_CONFIRMATION',
  WISORY_REGISTER_INTEREST = 'WISORY_REGISTER_INTEREST',
  WISORY_BOOKING_CONFIRMATION_ONLINE_PAYMENT = 'WISORY_BOOKING_CONFIRMATION_ONLINE_PAYMENT',
  WISORY_BOOKING_CONFIRMATION_INVOICE_PAYMENT = 'WISORY_BOOKING_CONFIRMATION_INVOICE_PAYMENT',
  CALENDAR_TO_ADVISOR_AVAILABILITY_CREATED = 'CALENDAR_TO_ADVISOR_AVAILABILITY_CREATED',
  CALENDAR_TO_ADVISOR_AND_USER_SESSION_BOOKED_WISORY_VIDEO = 'CALENDAR_TO_ADVISOR_AND_USER_SESSION_BOOKED_WISORY_VIDEO',
  CALENDAR_TO_ADVISOR_AND_USER_SESSION_BOOKED_NON_WISORY_VIDEO = 'CALENDAR_TO_ADVISOR_AND_USER_SESSION_BOOKED_NON_WISORY_VIDEO',
  CALENDAR_TO_USER_AND_ADVISOR_ADVISOR_SELECTED_SLOT_IN_TIMESPAN_USING_WISORY_VIDEO = 'CALENDAR_TO_USER_AND_ADVISOR_ADVISOR_SELECTED_SLOT_IN_TIMESPAN_USING_WISORY_VIDEO',
  CALENDAR_TO_USER_AND_ADVISOR_ADVISOR_SELECTED_SLOT_IN_TIMESPAN_NOT_USING_WISORY_VIDEO = 'CALENDAR_TO_USER_AND_ADVISOR_ADVISOR_SELECTED_SLOT_IN_TIMESPAN_NOT_USING_WISORY_VIDEO',
  CALENDAR_TO_USER_AND_ADVISOR_USER_ACCEPTED_TIMESLOT_SUGGESTION_USING_WISORY_VIDEO = 'CALENDAR_TO_USER_AND_ADVISOR_USER_ACCEPTED_TIMESLOT_SUGGESTION_USING_WISORY_VIDEO',
  CALENDAR_TO_USER_AND_ADVISOR_USER_ACCEPTED_TIMESLOT_SUGGESTION_NOT_USING_WISORY_VIDEO = 'CALENDAR_TO_USER_AND_ADVISOR_USER_ACCEPTED_TIMESLOT_SUGGESTION_NOT_USING_WISORY_VIDEO',
  WISORY_ONBOARDING_EMAIL = 'WISORY_ONBOARDING_EMAIL',
  MAIL_TO_ADVISOR_FIRST_SESSION_NO_FUTURE_SESSIONS_FROM_SYSTEM = 'MAIL_TO_ADVISOR_FIRST_SESSION_NO_FUTURE_SESSIONS_FROM_SYSTEM',
  MAIL_TO_ADVISOR_FIRST_SESSION_HAS_FUTURE_SESSIONS_FROM_SYSTEM = 'MAIL_TO_ADVISOR_FIRST_SESSION_HAS_FUTURE_SESSIONS_FROM_SYSTEM',
  MAIL_TO_ADVISOR_SUBSEQUENT_SESSION_FROM_SYSTEM = 'MAIL_TO_ADVISOR_SUBSEQUENT_SESSION_FROM_SYSTEM',
  WISORY_EMAIL_VERIFICATION = 'WISORY_EMAIL_VERIFICATION',
  WISORY_FALLBACK_EMAIL_GENERIC = 'WISORY_FALLBACK_EMAIL_GENERIC',
  MAIL_TO_USER_HOURS_PRE_SESSION_EMAIL_FROM_SYSTEM = 'MAIL_TO_USER_HOURS_PRE_SESSION_EMAIL_FROM_SYSTEM',
  MAIL_TO_ADVISOR_NEW_BOOKING_TIMESLOT_SUGGESTIONS = 'MAIL_TO_ADVISOR_NEW_BOOKING_TIMESLOT_SUGGESTIONS',
  MAIL_TO_ADVISOR_COUNTERPROPOSAL_FROM_USER = 'MAIL_TO_ADVISOR_COUNTERPROPOSAL_FROM_USER',
  MAIL_TO_USER_COUNTERPROPOSAL_FROM_USER = 'MAIL_TO_USER_COUNTERPROPOSAL_FROM_USER',
  MAIL_TO_ADVISOR_RESCHEDULE_SUGGESTION_FROM_USER = 'MAIL_TO_ADVISOR_RESCHEDULE_SUGGESTION_FROM_USER',
  MAIL_TO_ADVISOR_RESCHEDULE_SUGGESTION_FROM_ADVISOR = 'MAIL_TO_ADVISOR_RESCHEDULE_SUGGESTION_FROM_ADVISOR',
  MAIL_TO_USER_NEW_BOOKING_TIMESLOT_SUGGESTIONS = 'MAIL_TO_USER_NEW_BOOKING_TIMESLOT_SUGGESTIONS',
  MAIL_TO_USER_COUNTERPROPOSAL_FROM_ADVISOR = 'MAIL_TO_USER_COUNTERPROPOSAL_FROM_ADVISOR',
  MAIL_TO_USER_RESCHEDULE_SUGGESTION_FROM_ADVISOR = 'MAIL_TO_USER_RESCHEDULE_SUGGESTION_FROM_ADVISOR',
  MAIL_TO_USER_RESCHEDULE_SUGGESTION_FROM_USER = 'MAIL_TO_USER_RESCHEDULE_SUGGESTION_FROM_USER',
  MAIL_TO_USER_USER_SELECTED_TIMESLOT = 'MAIL_TO_USER_USER_SELECTED_TIMESLOT',
  MAIL_TO_ADVISOR_USER_ACCEPTED_TIMESLOT_SUGGESTION = 'MAIL_TO_ADVISOR_USER_ACCEPTED_TIMESLOT_SUGGESTION',
  MAIL_TO_USER_ADVISOR_SELECTED_SLOT_IN_TIMESPAN = 'MAIL_TO_USER_ADVISOR_SELECTED_SLOT_IN_TIMESPAN',
  MAIL_TO_ADVISOR_ADVISOR_SELECTED_SLOT_IN_TIMESPAN = 'MAIL_TO_ADVISOR_ADVISOR_SELECTED_SLOT_IN_TIMESPAN',
  MAIL_TO_MJML_TEST = 'MAIL_TO_MJML_TEST',
  MAIL_TO_MJML_TO_SCRIBAN = 'MAIL_TO_MJML_TO_SCRIBAN',
  MAIL_TO_ADVISOR_CALENDAR_INVITE_DECLINED = 'MAIL_TO_ADVISOR_CALENDAR_INVITE_DECLINED',
  MAIL_TO_USER_CALENDAR_INVITE_DECLINED = 'MAIL_TO_USER_CALENDAR_INVITE_DECLINED',
}

export enum EmailTemplateStatus {
  AVAILABLE = 'AVAILABLE',
  DELETED = 'DELETED',
}

export interface EmailTemplateView {
  /** @format int64 */
  id?: number;
  name?: string | null;
  description?: string | null;
  subject?: string | null;
  message?: string | null;
  locale?: string | null;
  contentType?: EmailTemplateContentType;
  status?: EmailTemplateStatus;
  /** @format int64 */
  version?: number;
  /** @format date-time */
  createdDate?: string;
  emailTemplateFormat?: EmailTemplateFormat;
}

export interface EmailTemplateViewPaginationResult {
  items?: EmailTemplateView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface EmailValidateObject {
  emailAddress?: string | null;
}

export interface EntityTypeView {
  name?: string | null;
}

export interface EntryPoint {
  accessCode?: string | null;
  entryPointFeatures?: string[] | null;
  entryPointType?: string | null;
  label?: string | null;
  meetingCode?: string | null;
  passcode?: string | null;
  password?: string | null;
  pin?: string | null;
  regionCode?: string | null;
  uri?: string | null;
  eTag?: string | null;
}

export interface ErrorResponse {
  statusCode?: HttpStatusCode;
  errorCode?: string | null;
  errorMessage?: string | null;
  errorData?: any;
}

export interface Event {
  anyoneCanAddSelf?: boolean | null;
  attachments?: EventAttachment[] | null;
  attendees?: EventAttendee[] | null;
  attendeesOmitted?: boolean | null;
  colorId?: string | null;
  conferenceData?: ConferenceData | null;
  createdRaw?: string | null;
  /** @format date-time */
  created?: string | null;
  creator?: CreatorData | null;
  description?: string | null;
  end?: EventDateTime | null;
  endTimeUnspecified?: boolean | null;
  eTag?: string | null;
  eventType?: string | null;
  extendedProperties?: ExtendedPropertiesData | null;
  gadget?: GadgetData | null;
  guestsCanInviteOthers?: boolean | null;
  guestsCanModify?: boolean | null;
  guestsCanSeeOtherGuests?: boolean | null;
  hangoutLink?: string | null;
  htmlLink?: string | null;
  iCalUID?: string | null;
  id?: string | null;
  kind?: string | null;
  location?: string | null;
  locked?: boolean | null;
  organizer?: OrganizerData | null;
  originalStartTime?: EventDateTime | null;
  privateCopy?: boolean | null;
  recurrence?: string[] | null;
  recurringEventId?: string | null;
  reminders?: RemindersData | null;
  /** @format int32 */
  sequence?: number | null;
  source?: SourceData | null;
  start?: EventDateTime | null;
  status?: string | null;
  summary?: string | null;
  transparency?: string | null;
  updatedRaw?: string | null;
  /** @format date-time */
  updated?: string | null;
  visibility?: string | null;
}

export interface EventAttachment {
  fileId?: string | null;
  fileUrl?: string | null;
  iconLink?: string | null;
  mimeType?: string | null;
  title?: string | null;
  eTag?: string | null;
}

export interface EventAttendee {
  /** @format int32 */
  additionalGuests?: number | null;
  comment?: string | null;
  displayName?: string | null;
  email?: string | null;
  id?: string | null;
  optional?: boolean | null;
  organizer?: boolean | null;
  resource?: boolean | null;
  responseStatus?: string | null;
  self?: boolean | null;
  eTag?: string | null;
}

export interface EventDateTime {
  date?: string | null;
  dateTimeRaw?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  timeZone?: string | null;
  eTag?: string | null;
}

export interface EventEventsExternalCalendarEventSearchResult {
  items?: Event[] | null;
  originalResult?: Events | null;
}

export interface EventReminder {
  method?: string | null;
  /** @format int32 */
  minutes?: number | null;
  eTag?: string | null;
}

export interface EventTracking {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  eventType: string;
  eventContextType: string;
  eventContextId?: string | null;
  eventTrackingMetadatas?: EventTrackingMetadata[] | null;
}

export interface EventTrackingMasterData {
  eventType?: string | null;
  eventContextType?: string | null;
  metadataKeys?: string[] | null;
}

export interface EventTrackingMetadata {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  eventTrackingId: number;
  key: string;
  value?: string | null;
  eventTracking?: EventTracking | null;
}

export interface EventTrackingPaginationResult {
  items?: EventTracking[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface EventTrackingSearchRequest {
  eventType?: string | null;
  contextType?: string | null;
  contextKey?: string | null;
  metadatas?: Record<string, string>;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  offset?: number;
}

export interface Events {
  accessRole?: string | null;
  defaultReminders?: EventReminder[] | null;
  description?: string | null;
  eTag?: string | null;
  items?: Event[] | null;
  kind?: string | null;
  nextPageToken?: string | null;
  nextSyncToken?: string | null;
  summary?: string | null;
  timeZone?: string | null;
  updatedRaw?: string | null;
  /** @format date-time */
  updated?: string | null;
}

export enum ExporterType {
  EXCEL = 'EXCEL',
  CSV = 'CSV',
}

export interface ExtendedPropertiesData {
  private__?: Record<string, string>;
  shared?: Record<string, string>;
}

export interface ExternalCalendarLinkRequest {
  /** @format int64 */
  bookingId?: number;
  platformType?: CalendarEventPlatformType;
  externalId: string;
  force?: boolean;
}

export interface ExternalCalendarSyncRequest {
  /** @format int64 */
  bookingId?: number;
}

export interface FailedLoginUserResponse {
  /** @format uuid */
  id?: string;
  userEmail?: string | null;
  reason?: FailedReason;
  /** @format date-time */
  failedTime?: string;
  method?: LoginMethod;
  userId?: string | null;
  reasonDescription?: string | null;
  methodDescription?: string | null;
}

export interface FailedLoginUserResponsePaginationResult {
  items?: FailedLoginUserResponse[] | null;
  /** @format int64 */
  totalCount?: number;
}

export enum FailedReason {
  NewEmail = 'NewEmail',
  WrongPassword = 'WrongPassword',
  WrongGoogleEmail = 'WrongGoogleEmail',
  WrongOtpChallenge = 'WrongOtpChallenge',
}

export interface FileExportResult {
  filePath?: string | null;
  mimeType?: string | null;
  fileName?: string | null;
}

export interface FileImportModel {
  importType?: ImportType;
  fileName?: string | null;
  status?: ImportStatus;
  /** @format uuid */
  fileImportId?: string;
}

export interface FileImportModelPaginationResult {
  items?: FileImportModel[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface GadgetData {
  display?: string | null;
  /** @format int32 */
  height?: number | null;
  iconLink?: string | null;
  link?: string | null;
  preferences?: Record<string, string>;
  title?: string | null;
  type?: string | null;
  /** @format int32 */
  width?: number | null;
}

export interface GetAdminUserTablePreferencesResponse {
  tableKey?: string | null;
  tableValue?: string | null;
  /** @format date-time */
  lastUpdatedDate?: string;
}

export interface GetAnonymousUserLoginResponse {
  salt?: string | null;
}

export interface GetAvailabilitiesSyncStatusRequest {
  appointmentIds?: number[] | null;
}

export interface GetBookingsSyncEmailStatusRequest {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  dynamicFilters?: string | null;
  dynamicSorts?: string | null;
  bookingIds?: number[] | null;
}

export interface GetBookingsSyncStatusRequest {
  bookingIds?: number[] | null;
}

export interface GetExistingSlot {
  /** @format int64 */
  advisorId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
}

export interface GetParameterResponse {
  responseMetadata?: ResponseMetadata | null;
  /** @format int64 */
  contentLength?: number;
  httpStatusCode?: HttpStatusCode;
  parameter?: Parameter | null;
}

export interface GetParametersByPathResponse {
  responseMetadata?: ResponseMetadata | null;
  /** @format int64 */
  contentLength?: number;
  httpStatusCode?: HttpStatusCode;
  nextToken?: string | null;
  parameters?: Parameter[] | null;
}

export interface GetRebookedCalendarEventsLogViewQuery {
  bookingIds?: number[] | null;
}

export interface GoogleCalendarEventAutoMatchingView {
  /** @format int64 */
  googleCalendarEventSyncId?: number;
  externalCalendarId?: string | null;
  /** @format int64 */
  suggestedMatchAppointmentAvailabilityId?: number;
}

export enum GoogleCalendarEventState {
  NONE = 'NONE',
  PREL = 'PREL',
  BOOKING = 'BOOKING',
}

export enum GoogleCalendarEventSyncStatus {
  NONE = 'NONE',
  SYNCED = 'SYNCED',
  MISMATCH = 'MISMATCH',
}

export interface GoogleCalendarEventSyncView {
  /** @format int64 */
  id?: number;
  externalCalendarId?: string | null;
  /** @format int64 */
  matchedAppointmentAvailabilityId?: number | null;
  /** @format int64 */
  matchedLastBookingId?: number | null;
  eventStatus?: string | null;
  eventStage?: GoogleCalendarEventState;
  syncStatus?: GoogleCalendarEventSyncStatus;
  eventSubject?: string | null;
  eventHtmlLink?: string | null;
  /** @format date-time */
  eventStartDate?: string;
  /** @format date-time */
  eventEndDate?: string;
  attendees?: string[] | null;
  attendeesAcceptInvitation?: string[] | null;
  /** @format int32 */
  totalAcceptedAttendees?: number;
  /** @format int32 */
  totalAttendees?: number;
  /** @format int32 */
  mismatchInfo?: number;
  lastSyncedMismatchInfoDetails?: string[] | null;
  /** @format date-time */
  eventLastUpdatedDate?: string | null;
  eventRawJson?: string | null;
  autoMatchingViews?: GoogleCalendarEventAutoMatchingView[] | null;
}

export interface GoogleCalendarEventSyncViewPaginationResult {
  items?: GoogleCalendarEventSyncView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface GoogleCalendarSearchNextQuery {
  pageToken?: string | null;
}

export interface GoogleCalendarSearchQuery {
  query?: string | null;
}

export enum HttpStatusCode {
  Continue = 'Continue',
  SwitchingProtocols = 'SwitchingProtocols',
  Processing = 'Processing',
  EarlyHints = 'EarlyHints',
  OK = 'OK',
  Created = 'Created',
  Accepted = 'Accepted',
  NonAuthoritativeInformation = 'NonAuthoritativeInformation',
  NoContent = 'NoContent',
  ResetContent = 'ResetContent',
  PartialContent = 'PartialContent',
  MultiStatus = 'MultiStatus',
  AlreadyReported = 'AlreadyReported',
  IMUsed = 'IMUsed',
  MultipleChoices = 'MultipleChoices',
  MovedPermanently = 'MovedPermanently',
  Found = 'Found',
  SeeOther = 'SeeOther',
  NotModified = 'NotModified',
  UseProxy = 'UseProxy',
  Unused = 'Unused',
  TemporaryRedirect = 'TemporaryRedirect',
  PermanentRedirect = 'PermanentRedirect',
  BadRequest = 'BadRequest',
  Unauthorized = 'Unauthorized',
  PaymentRequired = 'PaymentRequired',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  MethodNotAllowed = 'MethodNotAllowed',
  NotAcceptable = 'NotAcceptable',
  ProxyAuthenticationRequired = 'ProxyAuthenticationRequired',
  RequestTimeout = 'RequestTimeout',
  Conflict = 'Conflict',
  Gone = 'Gone',
  LengthRequired = 'LengthRequired',
  PreconditionFailed = 'PreconditionFailed',
  RequestEntityTooLarge = 'RequestEntityTooLarge',
  RequestUriTooLong = 'RequestUriTooLong',
  UnsupportedMediaType = 'UnsupportedMediaType',
  RequestedRangeNotSatisfiable = 'RequestedRangeNotSatisfiable',
  ExpectationFailed = 'ExpectationFailed',
  MisdirectedRequest = 'MisdirectedRequest',
  UnprocessableEntity = 'UnprocessableEntity',
  Locked = 'Locked',
  FailedDependency = 'FailedDependency',
  UpgradeRequired = 'UpgradeRequired',
  PreconditionRequired = 'PreconditionRequired',
  TooManyRequests = 'TooManyRequests',
  RequestHeaderFieldsTooLarge = 'RequestHeaderFieldsTooLarge',
  UnavailableForLegalReasons = 'UnavailableForLegalReasons',
  InternalServerError = 'InternalServerError',
  NotImplemented = 'NotImplemented',
  BadGateway = 'BadGateway',
  ServiceUnavailable = 'ServiceUnavailable',
  GatewayTimeout = 'GatewayTimeout',
  HttpVersionNotSupported = 'HttpVersionNotSupported',
  VariantAlsoNegotiates = 'VariantAlsoNegotiates',
  InsufficientStorage = 'InsufficientStorage',
  LoopDetected = 'LoopDetected',
  NotExtended = 'NotExtended',
  NetworkAuthenticationRequired = 'NetworkAuthenticationRequired',
}

export interface IEmailContent {
  subject?: string | null;
  htmlBody?: string | null;
  plainTextBody?: string | null;
  emailTemplateName?: string | null;
  emailTemplateFormat?: EmailTemplateFormat;
}

export interface IExternalUser {
  /** @format int64 */
  id?: number;
  userName?: string | null;
  email?: string | null;
  /** @format int64 */
  companyId?: number | null;
  professionalTitle?: CustomerProfessionalTitle | null;
  firstName?: string | null;
  lastName?: string | null;
  externalUserId?: string | null;
  phoneNumber?: string | null;
}

export interface IFileExportResult {
  fileName?: string | null;
  filePath?: string | null;
  mimeType?: string | null;
}

export interface IdentityRole {
  /** @format int64 */
  id?: number;
  name?: string | null;
  normalizedName?: string | null;
  concurrencyStamp?: string | null;
}

export interface IdentityUser {
  /** @format int64 */
  id?: number;
  userName?: string | null;
  normalizedUserName?: string | null;
  email?: string | null;
  normalizedEmail?: string | null;
  emailConfirmed?: boolean;
  passwordHash?: string | null;
  securityStamp?: string | null;
  concurrencyStamp?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  /** @format date-time */
  lockoutEnd?: string | null;
  lockoutEnabled?: boolean;
  /** @format int32 */
  accessFailedCount?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  description?: string | null;
  firstName?: string | null;
  fullName?: string | null;
  lastName?: string | null;
  status?: UserStatusEnum;
  professionalTitle?: CustomerProfessionalTitle | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  companyId?: number | null;
  externalUserId?: string | null;
  /** @format int64 */
  timeZoneId?: number | null;
  timeZoneData?: TimeZoneData | null;
  passwordChanged?: boolean;
  primaryAddress?: Address | null;
  company?: Company | null;
  companies?: Company[] | null;
  userTokens?: UserToken[] | null;
  rolesString?: string[] | null;
  metadata?: MetadataValue[] | null;
  /** @format date-time */
  lockoutEndDateUtc?: string | null;
  roles?: IdentityUserRole[] | null;
}

export interface IdentityUserRole {
  /** @format int64 */
  userId?: number;
  /** @format int64 */
  roleId?: number;
  identityUser?: IdentityUser | null;
  identityRole?: IdentityRole | null;
}

export interface IdentityUserView {
  /** @format int64 */
  id?: number;
  email?: string | null;
  phoneNumber?: string | null;
  userName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  createdBy?: string | null;
  lastModifiedBy?: string | null;
  primaryAddress?: AddressView | null;
  description?: string | null;
  company?: CompanyView | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  companyId?: number | null;
  professionalTitle?: CustomerProfessionalTitle | null;
  status?: UserStatusEnum;
  roles?: string[] | null;
  metadataSets?: MetadataSetView[] | null;
  fullName?: string | null;
  hadPassword?: boolean;
  /** @format int32 */
  totalSessionCount?: number | null;
  /** @format int32 */
  nextSessionCount?: number | null;
  /** @format date-time */
  nextBookingSessionDate?: string | null;
  /** @format date-time */
  lastBookingSessionDate?: string | null;
  /** @format int32 */
  totalLateSessionCount?: number | null;
  /** @format int32 */
  totalPerformedSessionCount?: number | null;
  timeZoneId?: string | null;
}

export interface IdentityUserViewPaginationResult {
  items?: IdentityUserView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface ImportAdvisorAvailabilityCommand {
  /** @format int64 */
  advisorAvailabilityImportId?: number;
  importOptions?: ImportAvailabilityOptions;
  locale?: string | null;
  toLockKey?: string | null;
}

export interface ImportAvailabilityGoogleFormItem {
  title?: string | null;
  type?: string | null;
  data?: any;
}

export interface ImportAvailabilityGoogleFormView {
  formId?: string | null;
  formTitle?: string | null;
  triggerUid?: string | null;
  formData?: ImportAvailabilityGoogleFormItem[] | null;
}

export enum ImportAvailabilityOptions {
  AllMatched = 'AllMatched',
}

export enum ImportStatus {
  Waiting = 'Waiting',
  Done = 'Done',
  Error = 'Error',
}

export enum ImportType {
  User = 'User',
}

export interface InitOnlinePaymentResponseView {
  gatewayTransactionId?: string | null;
  gatewayPublicKey?: string | null;
  paymentSystemType?: string | null;
  /** @format int64 */
  invoiceId?: number;
}

export interface InterestRequestResponse {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorFullName?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerFullName?: string | null;
  customerInfoAsJson?: string | null;
  notes?: string | null;
  /** @format date-time */
  createdDate?: string;
  otherTimeSlotRequest?: string | null;
  timeSlots?: InterestRequestTimeSlotView[] | null;
  reference?: string | null;
  reason?: string | null;
  billingAddress?: string | null;
}

export interface InterestRequestResponsePaginationResult {
  items?: InterestRequestResponse[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface InterestRequestTimeSlotView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  interestRequestId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
}

export interface InvoiceRecipientInfo {
  customerName?: string | null;
  customerEmail?: string | null;
  customerCompany?: string | null;
  customerPhoneNumber?: string | null;
  customerBillingAddress?: string | null;
}

export interface InvoiceRecipientInfoView {
  customerName?: string | null;
  customerEmail?: string | null;
  customerCompany?: string | null;
  customerPhoneNumber?: string | null;
  customerBillingAddress?: string | null;
}

export enum InvoiceStatus {
  INIT = 'INIT',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
}

export enum InvoiceType {
  NONE = 'NONE',
  ONLINE_BOOKING_APPOINTMENT = 'ONLINE_BOOKING_APPOINTMENT',
  ONLINE_INVOICE_BOOKING_APPOINTMENT = 'ONLINE_INVOICE_BOOKING_APPOINTMENT',
  MANUAL_INVOICE_BOOKING_APPOINTMENT = 'MANUAL_INVOICE_BOOKING_APPOINTMENT',
}

export interface InvoiceView {
  /** @format int64 */
  id?: number;
  /** @format double */
  amount?: number;
  currency?: string | null;
  recipientInfo?: InvoiceRecipientInfo | null;
  invoiceContent?: StripeCheckoutOrderItem[] | null;
  /** @deprecated */
  paymentStatus?: PaymentStatus;
  invoiceStatus?: InvoiceStatus;
  invoiceType?: InvoiceType;
  transaction?: TransactionView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
}

export interface InvoiceViewPaginationResult {
  items?: InvoiceView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface JobExecutionSuccess {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  jobType: string;
  contextType: string;
  contextKey: string;
  /** @format date-time */
  executedAt: string;
  message?: string | null;
}

export interface JobExecutionSuccessPaginationResult {
  items?: JobExecutionSuccess[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface LocaleDto {
  locale?: string | null;
  name?: string | null;
}

export enum LoginMethod {
  Otp = 'Otp',
  Password = 'Password',
  Token = 'Token',
}

export interface LoginView {
  authorizationCode?: string | null;
  callbackUrl?: string | null;
}

export interface LoginWithBookingOTPView {
  /** @format int64 */
  bookingId?: number;
  token?: string | null;
}

export interface LoginWithOTPView {
  /** @format email */
  emailAddress?: string | null;
  token?: string | null;
}

export enum MetadataDisplayType {
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  DATE = 'DATE',
}

export interface MetadataOption {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  metadataSetId: number;
  displayName: string;
  value?: string | null;
  metadataSet?: MetadataSet | null;
}

export interface MetadataSet {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  name: string;
  entityType: string;
  description?: string | null;
  displayType?: MetadataDisplayType;
  metadataOptions?: MetadataOption[] | null;
}

export interface MetadataSetOptionView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  metadataSetId?: number;
  displayName?: string | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  value?: string | null;
}

export interface MetadataSetView {
  /** @format int64 */
  id?: number;
  name?: string | null;
  description?: string | null;
  displayType?: MetadataDisplayType;
  entityType?: string | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  lastModifiedDate?: string;
  options?: MetadataSetOptionView[] | null;
  value?: string | null;
}

export interface MetadataValue {
  /** @format int64 */
  entityId: number;
  /** @format int64 */
  metadataSetId: number;
  value?: string | null;
  metadataSet?: MetadataSet | null;
  /** @format int64 */
  identityUserId?: number | null;
  identityUser?: IdentityUser | null;
}

export interface MetadataView {
  /** @format int64 */
  entityId?: number;
  /** @format int64 */
  metadataSetId?: number;
  value?: string | null;
}

export interface MjmlModelTest {
  name?: string | null;
  testContent?: string | null;
  subject?: string | null;
}

export interface NotificationSettingsData {
  notifications?: CalendarNotification[] | null;
}

export interface OTPVerificationView {
  /** @format email */
  emailAddress?: string | null;
}

export interface OnlinePaymentCustomerInfo {
  email?: string | null;
  name?: string | null;
  company?: string | null;
  phoneNumber?: string | null;
}

export interface Operation {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any;
}

export enum OperationType {
  Add = 'Add',
  Remove = 'Remove',
  Replace = 'Replace',
  Move = 'Move',
  Copy = 'Copy',
  Test = 'Test',
  Invalid = 'Invalid',
}

export enum OrderItemProductType {
  NONE = 'NONE',
  BOOKING_APPOINTMENT_AVAILABILITY = 'BOOKING_APPOINTMENT_AVAILABILITY',
}

export interface OrganizerData {
  displayName?: string | null;
  email?: string | null;
  id?: string | null;
  self?: boolean | null;
}

export interface OtpAnswerView {
  /** @format email */
  emailAddress?: string | null;
  session?: string | null;
  challengeName?: string | null;
  challengeAnswer?: string | null;
}

export interface OtpBookingVerificationView {
  /** @format int64 */
  bookingId?: number;
}

export interface OtpChallengeView {
  session?: string | null;
  challengeName?: string | null;
}

export enum PackageOrderStatus {
  New = 'New',
  Processing = 'Processing',
  Completed = 'Completed',
  Deleted = 'Deleted',
}

export interface PackageOrderView {
  packageId?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  isTermAccepted?: boolean;
  /** @format int64 */
  packageOrderId?: number;
  status?: PackageOrderStatus;
}

export interface PackageOrderViewPaginationResult {
  items?: PackageOrderView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface Parameter {
  arn?: string | null;
  dataType?: string | null;
  /** @format date-time */
  lastModifiedDate?: string;
  name?: string | null;
  selector?: string | null;
  sourceResult?: string | null;
  type?: ParameterType | null;
  value?: string | null;
  /** @format int64 */
  version?: number;
}

export interface ParameterStringFilter {
  key?: string | null;
  option?: string | null;
  values?: string[] | null;
}

export interface ParameterTier {
  value?: string | null;
}

export interface ParameterType {
  value?: string | null;
}

export enum PaymentStatus {
  PAYMENT_INIT = 'PAYMENT_INIT',
  PAYMENT_CREATED = 'PAYMENT_CREATED',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',
}

export interface PhoneNumberValidateObject {
  phoneNumber?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
}

export interface PublicApplicationSettingsView {
  isUsingWisoryVideoPlatform?: boolean;
  isProfileAppEnabled?: boolean;
  isVideoAppSurveyEnabled?: boolean;
  videoPlatforms?: string[] | null;
  useCognitoOtpLogin?: boolean;
  isAutoRebuyFeatureEnabled?: boolean;
  isAutoBuyVerificationEnabled?: boolean;
  videoAppSurveyWidgetToken?: string | null;
  isBookingFormWisoryVideoEnabled?: boolean;
  /** @format int32 */
  bookingFormAvailabilityOffset?: number;
  isPingPongWorkflowEnabled?: boolean;
  smsProvider?: string | null;
  emailWhiteLists?: string | null;
  isWisoryVideoNextEnabled?: boolean;
}

export interface PublicAppointmentAvailabilityView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
}

export interface PublicRebuyBookingCalendarView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  advisorId?: number;
  advisorName?: string | null;
  advisorEmail?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerName?: string | null;
  customerEmail?: string | null;
  companyName?: string | null;
  companyEmail?: string | null;
  locale?: string | null;
}

export interface PublicRegisterInterestView {
  /** @format int64 */
  advisorId?: number;
  other?: string | null;
  reference?: string | null;
  notes?: string | null;
  reason?: string | null;
  customerInfo?: RegisterInterestCustomerInfo | null;
  timeSlotRequests?: TimeSlotRequestView[] | null;
  otherTimeSlotRequest?: string | null;
  billingAddress?: string | null;
}

export interface PutParameterResponse {
  responseMetadata?: ResponseMetadata | null;
  /** @format int64 */
  contentLength?: number;
  httpStatusCode?: HttpStatusCode;
  tier?: ParameterTier | null;
  /** @format int64 */
  version?: number;
}

export interface RebookCalendarEventView {
  /** @format int64 */
  calendarEventId?: number;
  /** @format date-time */
  newStartTime?: string;
  shortDescription?: string | null;
}

export interface RebookedCalendarEventLogEntryView {
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
}

export interface RebookedCalendarEventLogView {
  /** @format int64 */
  calendarEventId?: number;
  entries?: RebookedCalendarEventLogEntryView[] | null;
  /** @format int32 */
  count?: number;
}

export interface RebuyBookingCalendarEventAvailableSlotCheckRequest {
  /** @format int64 */
  previousBookingId?: number;
  /** @format int64 */
  currentUserId?: number;
  /** @format date-time */
  bookingTime?: string;
  /** @format date-time */
  startDateTime?: string;
  /** @format date-time */
  endDateTime?: string;
}

export interface RebuyBookingCalendarEventRequest {
  locale?: string | null;
  /** @format int64 */
  currentUserId?: number;
  /** @format int64 */
  previousBookingId?: number;
  advisorEmail?: string | null;
  customerEmail?: string | null;
  customerFullName?: string | null;
  customerCompany?: string | null;
  advisorFullName?: string | null;
  /** @format date-time */
  bookingTime?: string;
  purpose?: string | null;
  other?: string | null;
}

export interface RebuyBookingCalendarEventResponse {
  bookingCalendarEvent?: BookingCalendarEventDto | null;
  sendingCustomerExperienceToAdvisorResponse?: SendingCustomerExperienceToAdvisorResponse | null;
}

export interface RefreshTokenView {
  refreshToken: string;
}

export interface RegisterInterestCustomerInfo {
  email?: string | null;
  name?: string | null;
  company?: string | null;
  phoneNumber?: string | null;
}

export interface RegisterInterestView {
  /** @format int64 */
  advisorId?: number;
  /** @format int64 */
  customerId?: number | null;
  other?: string | null;
  reference?: string | null;
  notes?: string | null;
  reason?: string | null;
  platformType?: CalendarEventPlatformType;
  timeSlotRequests?: TimeSlotRequestView[] | null;
  otherTimeSlotRequest?: string | null;
  isSuggestionToAdvisor?: boolean;
}

export interface RemindersData {
  overrides?: EventReminder[] | null;
  useDefault?: boolean | null;
}

export interface ResponseMetadata {
  requestId?: string | null;
  metadata?: Record<string, string>;
  checksumAlgorithm?: CoreChecksumAlgorithm;
  checksumValidationStatus?: ChecksumValidationStatus;
}

export interface SearchEventDeltaRequest {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  offset?: number;
  filter?: string | null;
  query?: string | null;
  sortOrder?: string | null;
  calendarEventIds?: number[] | null;
}

export interface SearchIdentityUserView {
  /** @format int64 */
  id?: number;
  userName?: string | null;
  normalizedUserName?: string | null;
  email?: string | null;
  normalizedEmail?: string | null;
  emailConfirmed?: boolean;
  passwordHash?: string | null;
  securityStamp?: string | null;
  concurrencyStamp?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  /** @format date-time */
  lockoutEnd?: string | null;
  lockoutEnabled?: boolean;
  /** @format int32 */
  accessFailedCount?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  description?: string | null;
  firstName?: string | null;
  fullName?: string | null;
  lastName?: string | null;
  status?: UserStatusEnum;
  professionalTitle?: CustomerProfessionalTitle | null;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  companyId?: number | null;
  externalUserId?: string | null;
  /** @format int64 */
  timeZoneId?: number | null;
  timeZoneData?: TimeZoneData | null;
  passwordChanged?: boolean;
  primaryAddress?: Address | null;
  company?: Company | null;
  companies?: Company[] | null;
  userTokens?: UserToken[] | null;
  rolesString?: string[] | null;
  metadata?: MetadataValue[] | null;
  /** @format date-time */
  lockoutEndDateUtc?: string | null;
  roles?: IdentityUserRole[] | null;
  /** @format date-time */
  lastBookingSessionDate?: string | null;
  /** @format date-time */
  nextBookingSessionDate?: string | null;
  /** @format int32 */
  nextSessionCount?: number;
  /** @format int32 */
  totalSessionCount?: number;
}

export interface SearchIdentityUserViewPaginationResult {
  items?: SearchIdentityUserView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface SendEmailRequest {
  emailTemplateName: string;
  locale: string;
  emailData?: any;
  to: string[];
}

export interface SendMailView {
  subject: string;
  message: string;
  from: string;
  to: string[];
}

export interface SendingCustomerExperienceToAdvisorResponse {
  /** @format int64 */
  bookingId?: number;
  /** @format int64 */
  advisorId?: number;
  /** @format int64 */
  customerId?: number | null;
  /** @format int32 */
  numberOfPreviousBookings?: number;
}

export interface SourceData {
  title?: string | null;
  url?: string | null;
}

export interface StripeCardPaymentTransactionView {
  /** @format int64 */
  id?: number;
  status?: TransactionStatus;
  type?: TransactionType;
  externalTransactionId?: string | null;
  /** @format int64 */
  invoiceId?: number;
  transactionDiscriminator?: TransactionDiscriminator;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  sessionId?: string | null;
  paymentIntentId?: string | null;
  /** @format int64 */
  lastCapturedEventTimestamp?: number | null;
  lastCapturedEventId?: string | null;
  externalStatus?: string | null;
  eventDataAsJson?: any;
  paymentCreationAsJson?: any;
}

export interface StripeCardPaymentTransactionViewPaginationResult {
  items?: StripeCardPaymentTransactionView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface StripeCheckoutOrderItem {
  productId?: string | null;
  productType?: OrderItemProductType;
  /** @format int32 */
  quantity?: number;
  /** @format int64 */
  amount?: number;
  currency?: string | null;
  metadata?: Record<string, string | null>;
  productName?: string | null;
  description?: string | null;
  imageUrls?: string[] | null;
}

export interface TimeSlotRequestView {
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
}

export interface TimeZoneData {
  /** @format int64 */
  id?: number;
  displayName?: string | null;
  timeZoneId?: string | null;
  users?: IdentityUser[] | null;
}

export interface TokenResultView {
  userName?: string | null;
  accessToken?: string | null;
  refreshToken?: string | null;
  userId?: string | null;
  tokenType?: string | null;
  expiresIn?: string | null;
  /** @format int64 */
  issuedAt?: number;
  /** @format int64 */
  expiresAt?: number;
  isSuccess?: boolean;
  session?: string | null;
  errorMessage?: string | null;
  emailAddress?: string | null;
}

export enum TokenTypeEnum {
  Login = 'Login',
  Anonymous = 'Anonymous',
  PhoneNumberVerification = 'PhoneNumberVerification',
  EmailVerification = 'EmailVerification',
}

export enum TransactionDiscriminator {
  NONE = 'NONE',
  STRIPE_CHECKOUT_CARD_PAYMENT_TRANSACTION = 'STRIPE_CHECKOUT_CARD_PAYMENT_TRANSACTION',
  INVOICE_PAYMENT_TRANSACTION = 'INVOICE_PAYMENT_TRANSACTION',
}

export enum TransactionStatus {
  INIT = 'INIT',
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export enum TransactionType {
  NONE = 'NONE',
  CHARGE = 'CHARGE',
  CHECK = 'CHECK',
  DEPOSIT = 'DEPOSIT',
  ONLINE = 'ONLINE',
  POS = 'POS',
  TRANSFER = 'TRANSFER',
  WITHDRAWAL = 'WITHDRAWAL',
}

export interface TransactionView {
  /** @format int64 */
  id?: number;
  status?: TransactionStatus;
  type?: TransactionType;
  externalTransactionId?: string | null;
  /** @format int64 */
  invoiceId?: number;
  transactionDiscriminator?: TransactionDiscriminator;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
}

export interface TransactionViewPaginationResult {
  items?: TransactionView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface UnapprovedImportAdvisorAvailabilitiesCommand {
  advisorAvailabilityImportIds?: number[] | null;
}

export interface UnapprovedImportAdvisorAvailabilityCommand {
  /** @format int64 */
  advisorAvailabilityImportId?: number;
}

export interface UnapprovedImportAdvisorAvailabilityResponse {
  isSuccess?: boolean;
  availabilityImportItem?: AdvisorAvailabilityImportDto | null;
  /** @format int64 */
  id?: number;
  displayStatus?: string | null;
  status?: AdvisorAvailabilityImportWithImportStatus;
  exception?: string | null;
}

export interface UpdateAppointmentAvailabilitySessionPriceView {
  /** @format double */
  price?: number;
}

export interface UpdateAppointmentAvailabilityView {
  /** @format int64 */
  advisorId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  validFrom?: string | null;
  /** @format date-time */
  expiryDate?: string | null;
  locale?: string | null;
  /** @format int64 */
  id?: number;
}

export interface UpdateCalendarEventResponse {
  /** @format int64 */
  calendarEventId?: number;
  /** @format int64 */
  calendarEventHistoryId?: number | null;
}

export interface UpdateCompanyBookingSessionView {
  /** @format int64 */
  bookingSessionCredit?: number;
}

export interface UpdateMetadataSetOptionView {
  value: string;
}

export interface UpdateMetadataSetView {
  description?: string | null;
}

export interface UpdateParameterStoreRequest {
  path?: string | null;
  value?: string | null;
  type?: ParameterType | null;
}

export interface UpdatePasswordByAdminView {
  newPassword: string;
}

export interface UpdateUserNameView {
  userName: string;
}

export interface UpdateUserView {
  firstName?: string | null;
  lastName?: string | null;
  description?: string | null;
  userName?: string | null;
  /** @format email */
  email?: string | null;
  phoneNumber?: string | null;
  status?: UserStatusEnum;
  /** @format int64 */
  companyId?: number | null;
  professionalTitle?: CustomerProfessionalTitle | null;
}

export interface UpsertAdminUserTablePreferencesRequest {
  userId?: string | null;
  tableKey?: string | null;
  tableValue?: string | null;
}

export interface UpsertAdminUserTablePreferencesResponse {
  tableKey?: string | null;
  tableValue?: string | null;
  /** @format date-time */
  lastUpdatedDate?: string;
}

export enum UserBackgroundEmailEnum {
  FirstUserBackgroundEmail = 'FirstUserBackgroundEmail',
  FirstUserBackgroundEmailWithFutureSession = 'FirstUserBackgroundEmailWithFutureSession',
  AlreadyBookUserBackgroundEmail = 'AlreadyBookUserBackgroundEmail',
}

export interface UserBookingSessionHistoryView {
  /** @format int64 */
  userId?: number | null;
  userName?: string | null;
  userEmail?: string | null;
  userTelephone?: string | null;
}

export interface UserEmailStatus {
  /** @format int64 */
  appointmentAvailabilityId?: number | null;
  eventType?: EmailEventType | null;
  emailAddress?: string | null;
  emailAddressType?: EmailAddressType;
  emailType?: EmailTemplateNameEnum | null;
}

export interface UserEmailStatusPaginationResult {
  items?: UserEmailStatus[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface UserHistoryView {
  /** @format int64 */
  rowId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  createdByUser?: IdentityUserView | null;
  lastModifiedByUser?: IdentityUserView | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /** @format date-time */
  rowInsertedDate?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  description?: string | null;
  status?: UserStatusEnum;
  /** @format int64 */
  primaryAddressId?: number | null;
  /** @format int64 */
  companyId?: number | null;
}

export interface UserHistoryViewPaginationResult {
  items?: UserHistoryView[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface UserImportDetailModel {
  /** @format uuid */
  fileImportId?: string;
  /** @format int64 */
  companyId?: number;
  /** @format int32 */
  rowId?: number;
  dataAsJson?: string | null;
  status?: ImportStatus;
  errorMessage?: string | null;
  /** @format int64 */
  userId?: number | null;
  fullName?: string | null;
}

export interface UserImportDetailModelPaginationResult {
  items?: UserImportDetailModel[] | null;
  /** @format int64 */
  totalCount?: number;
}

export interface UserImportErrorItem {
  /** @format int32 */
  rowId?: number;
  fieldName?: string | null;
  errorMessage?: string | null;
  errorMessageCode?: string | null;
  value?: string | null;
}

export enum UserStatusEnum {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  DELETED = 'DELETED',
}

export interface UserToken {
  /** @format int64 */
  id?: number;
  createdByUser?: IdentityUser | null;
  lastModifiedByUser?: IdentityUser | null;
  /** @format int64 */
  createdByUserId?: number | null;
  /** @format int64 */
  lastModifiedByUserId?: number | null;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  hashedToken?: string | null;
  salt?: string | null;
  tokenType?: TokenTypeEnum;
  /** @format date-time */
  expiredAt?: string;
  /** @format int64 */
  identityUserId?: number;
  identityUser?: IdentityUser | null;
}

export interface ValidationResultObject {
  isSuccess?: boolean;
  data?: any;
}

export enum WhoBookType {
  Admin = 'Admin',
  Advisor = 'Advisor',
  Customer = 'Customer',
}

export enum WisoryPingPongApiClientBookingQualityEnum {
  Untrack = 'Untrack',
  Valid = 'Valid',
  NeedsWork = 'NeedsWork',
}

export enum WisoryPingPongApiClientInterestRequestStatus {
  NONE = 'NONE',
  ADVISOR_COUNTER_PROPOSAL = 'ADVISOR_COUNTER_PROPOSAL',
  ADVISOR_BOOK_A_SLOT = 'ADVISOR_BOOK_A_SLOT',
  CUSTOMER_COUNTER_PROPOSAL = 'CUSTOMER_COUNTER_PROPOSAL',
  CUSTOMER_BOOK_A_SLOT = 'CUSTOMER_BOOK_A_SLOT',
  CUSTOMER_SUGGESTED_TIMESLOTS = 'CUSTOMER_SUGGESTED_TIMESLOTS',
  CANCEL = 'CANCEL',
}

export interface WisoryPingPongApiClientInterestRequestView {
  /** @format uuid */
  id?: string;
  /** @format int64 */
  advisorId?: number;
  advisorFullName?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customerFullName?: string | null;
  notes?: string | null;
  /** @format date-time */
  createdDate?: string;
  otherTimeSlotRequest?: string | null;
  timeSlots?: WisoryPingPongApiClientTimeSlotRequestModel[] | null;
  advisorSuggestTimeSlots?: WisoryPingPongApiClientTimeSlotRequestModel[] | null;
  customerSuggestTimeSlots?: WisoryPingPongApiClientTimeSlotRequestModel[] | null;
  reference?: string | null;
  reason?: string | null;
  locale?: string | null;
  status?: WisoryPingPongApiClientInterestRequestStatus;
  message?: string | null;
  /** @format int64 */
  bookingId?: number;
  /** @format int32 */
  pingPongCount?: number | null;
  /** @format date-time */
  lastModifiedDate?: string;
  isRescheduled?: boolean;
  wasRescheduled?: boolean;
  companyName?: string | null;
  /** @format int64 */
  companyId?: number | null;
  /** @format int64 */
  rescheduledUserId?: number | null;
  /** @format int32 */
  latestVersion?: number;
  bookingQuality?: WisoryPingPongApiClientBookingQualityEnum;
  /** @format date-time */
  bookedStartTime?: string | null;
  /** @format date-time */
  bookedEndTime?: string | null;
  advisorFirstName?: string | null;
  advisorLastName?: string | null;
  customerFirstName?: string | null;
  customerLastName?: string | null;
}

export interface WisoryPingPongApiClientTimeSlotRequestModel {
  /** @format date-time */
  startTimeOffset?: string;
  /** @format date-time */
  endTimeOffset?: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format uuid */
  id?: string | null;
  /** @format uuid */
  interestRequestId?: string | null;
  status?: WisoryPingPongApiClientTimeSlotStatusEnum;
  slotType?: WisoryPingPongApiClientInterestRequestStatus;
  hashData?: string | null;
  isSelected?: boolean;
  /** @format int32 */
  version?: number;
}

export enum WisoryPingPongApiClientTimeSlotStatusEnum {
  Available = 'Available',
  Booked = 'Booked',
}

export interface WisoryVideoApiClientGetWisoryVideoStatusResponse {
  /** @format int64 */
  bookingId?: number;
  roomName?: string | null;
  /** @format int64 */
  totalPackets?: number;
  /** @format int64 */
  totalPacketLoss?: number;
  /** @format int64 */
  lowestNetworkQualityLevel?: number;
  /** @format double */
  highestPacketLoss?: number;
  /** @format int64 */
  lostPercentage?: number;
  levelStatus?: WisoryVideoApiClientVideoRoomStatus;
}

export interface WisoryVideoApiClientParticipantDetail {
  /** @format uuid */
  id?: string;
  status?: WisoryVideoApiClientParticipantStatus;
  /** @format int32 */
  type?: number;
  identity?: string | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
}

export enum WisoryVideoApiClientParticipantStatus {
  Inactive = 'Inactive',
  Join = 'Join',
  Disconnect = 'Disconnect',
  Rejoin = 'Rejoin',
}

export interface WisoryVideoApiClientSessionDetailInternalResponse {
  /** @format uuid */
  id?: string;
  /** @format int64 */
  bookingId?: number | null;
  name?: string | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format int32 */
  numberOfParticipants?: number;
  status?: WisoryVideoApiClientSessionStatus;
  participants?: WisoryVideoApiClientParticipantDetail[] | null;
  videoSessionLink?: string | null;
  videoId?: string | null;
  createRoomResponseAsJson?: string | null;
  videoPlatform?: WisoryVideoApiClientVideoPlatform;
  isVideoCallRoomCreated?: boolean;
}

export enum WisoryVideoApiClientSessionStatus {
  Inactive = 'Inactive',
  Open = 'Open',
  Close = 'Close',
}

export enum WisoryVideoApiClientVideoPlatform {
  Twilio = 'Twilio',
  MsTeam = 'MsTeam',
}

export enum WisoryVideoApiClientVideoRoomStatus {
  Unknown = 'Unknown',
  Green = 'Green',
  Warning = 'Warning',
  Error = 'Error',
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof any]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: Iterable<any> = property instanceof Array ? property : [property];

      // @ts-ignore
      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Wisory API
 * @version v1
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Healthcheck
   * @name HomePage
   * @request GET:/
   * @secure
   */
  homePage = (params: RequestParams = {}) =>
    this.http.request<any, ErrorResponse>({
      path: `/`,
      method: 'GET',
      secure: true,
      ...params,
    });

  api = {
    /**
     * No description
     *
     * @tags UserProfile
     * @name GetMyAccount
     * @request GET:/api/users/me
     * @secure
     */
    getMyAccount: (params: RequestParams = {}) =>
      this.http.request<IdentityUserView, string>({
        path: `/api/users/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
    /**
     * No description
     *
     * @tags Address
     * @name GetAddressById
     * @request GET:/api/addresses/{addressId}
     * @secure
     */
    getAddressById: (addressId: number, params: RequestParams = {}) =>
      this.http.request<AddressView, ErrorResponse | string>({
        path: `/api/addresses/${addressId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name UpdateAddress
     * @request PUT:/api/addresses/{addressId}
     * @secure
     */
    updateAddress: (addressId: number, data: CreateAddressView, params: RequestParams = {}) =>
      this.http.request<AddressView, ErrorResponse | string>({
        path: `/api/addresses/${addressId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name RemoveAddress
     * @request DELETE:/api/addresses/{addressId}
     * @secure
     */
    removeAddress: (addressId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse | string>({
        path: `/api/addresses/${addressId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name GetAddresses
     * @request GET:/api/addresses
     * @secure
     */
    getAddresses: (
      query?: {
        /** @format int32 */
        currentPage?: number;
        /** @format int32 */
        pageSize?: number;
        filter?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AddressViewPaginationResult, ErrorResponse | string>({
        path: `/api/addresses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name CreateAddress
     * @request POST:/api/addresses
     * @secure
     */
    createAddress: (data: CreateAddressView, params: RequestParams = {}) =>
      this.http.request<AddressView, ErrorResponse | string>({
        path: `/api/addresses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name SetAddressAsPrimary
     * @request PUT:/api/addresses/{addressId}/primary
     * @secure
     */
    setAddressAsPrimary: (addressId: number, params: RequestParams = {}) =>
      this.http.request<AddressView, ErrorResponse | string>({
        path: `/api/addresses/${addressId}/primary`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUserTablePreferences
     * @name AdminUserTablePreferencesGetUserTablePreferences
     * @request GET:/api/table-preferences/{userId}
     * @secure
     */
    adminUserTablePreferencesGetUserTablePreferences: (
      userId: number,
      query?: {
        tableKey?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetAdminUserTablePreferencesResponse, ErrorResponse>({
        path: `/api/table-preferences/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUserTablePreferences
     * @name AdminUserTablePreferencesUpdateUserTablePreferences
     * @request POST:/api/table-preferences/{userId}
     * @secure
     */
    adminUserTablePreferencesUpdateUserTablePreferences: (
      userId: number,
      data: UpsertAdminUserTablePreferencesRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<UpsertAdminUserTablePreferencesResponse, ErrorResponse>({
        path: `/api/table-preferences/${userId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingCalendarEvent
     * @name GetBookingCalendarEventDetailsInternal
     * @request GET:/api/v1/internal/calendars/{calendarEventId}
     * @secure
     */
    getBookingCalendarEventDetailsInternal: (
      calendarEventId: number,
      query?: {
        isHideSensitiveInformation?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDetailInternalResponse, ErrorResponse | ProblemDetails>({
        path: `/api/v1/internal/calendars/${calendarEventId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comment
     * @name GetAllComments
     * @request GET:/api/comments
     * @secure
     */
    getAllComments: (
      query?: {
        EntityType?: string;
        EntityId?: string;
        /** @format int32 */
        PageIndex?: number;
        /** @format int32 */
        PageSize?: number;
        DynamicFilters?: string;
        DynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<CommentViewPaginationResult, ErrorResponse | string>({
        path: `/api/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comment
     * @name CreateAComment
     * @request POST:/api/comments
     * @secure
     */
    createAComment: (data: CreateCommentRequest, params: RequestParams = {}) =>
      this.http.request<CreateCommentResponse, ErrorResponse | string>({
        path: `/api/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetCompanyById
     * @request GET:/api/companies/{companyId}
     * @secure
     */
    getCompanyById: (companyId: number, params: RequestParams = {}) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name UpdateCompany
     * @request PUT:/api/companies/{companyId}
     * @secure
     */
    updateCompany: (companyId: number, data: CreateCompanyView, params: RequestParams = {}) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetCompanyUsersByCompanyId
     * @request GET:/api/companies/{companyId}/users
     * @secure
     */
    getCompanyUsersByCompanyId: (
      companyId: number,
      query?: {
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        currentPage?: number;
        filter?: string;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<CompanyUserViewPaginationResult, ErrorResponse | string>({
        path: `/api/companies/${companyId}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetCompanies
     * @request GET:/api/companies
     * @secure
     */
    getCompanies: (
      query?: {
        /** @format int32 */
        currentPage?: number;
        /** @format int32 */
        pageSize?: number;
        filter?: string;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<CompanyViewPaginationResult, ErrorResponse | string>({
        path: `/api/companies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name CreateCompany
     * @request POST:/api/companies
     * @secure
     */
    createCompany: (data: CreateCompanyView, params: RequestParams = {}) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name UpdateCompanyBookingSession
     * @request PUT:/api/companies/{companyId}/bookingSession
     * @secure
     */
    updateCompanyBookingSession: (
      companyId: number,
      data: UpdateCompanyBookingSessionView,
      params: RequestParams = {}
    ) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}/bookingSession`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetCompanyBookingSessionHistory
     * @request GET:/api/companies/{companyId}/bookingSessionHistories
     * @secure
     */
    getCompanyBookingSessionHistory: (
      companyId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingSessionHistoryViewPaginationResult, ErrorResponse | string>({
        path: `/api/companies/${companyId}/bookingSessionHistories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name AssignUserToCompany
     * @request POST:/api/companies/{companyId}/users/{userId}
     * @secure
     */
    assignUserToCompany: (
      companyId: number,
      userId: number,
      data: AssignUserToCompanyView,
      params: RequestParams = {}
    ) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}/users/${userId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name UnassignCompanyUser
     * @request DELETE:/api/companies/{companyId}/users/{userId}
     * @secure
     */
    unassignCompanyUser: (companyId: number, userId: number, params: RequestParams = {}) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}/users/${userId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name AssignAddressToCompany
     * @request POST:/api/companies/{companyId}/addresses/{addressId}
     * @secure
     */
    assignAddressToCompany: (
      companyId: number,
      addressId: number,
      data: AssignAddressToCompanyView,
      params: RequestParams = {}
    ) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}/addresses/${addressId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name UnassignCompanyAddress
     * @request DELETE:/api/companies/{companyId}/addresses/{addressId}
     * @secure
     */
    unassignCompanyAddress: (companyId: number, addressId: number, params: RequestParams = {}) =>
      this.http.request<CompanyView, ErrorResponse | string>({
        path: `/api/companies/${companyId}/addresses/${addressId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetCompanyHistories
     * @request GET:/api/companies/{companyId}/histories
     * @secure
     */
    getCompanyHistories: (
      companyId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<CompanyHistoryViewPaginationResult, ErrorResponse>({
        path: `/api/companies/${companyId}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetExportedCsvOfCompanyOverview
     * @request GET:/api/companies/export
     * @secure
     */
    getExportedCsvOfCompanyOverview: (
      query?: {
        exporter?: ExporterType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FileExportResult, ErrorResponse>({
        path: `/api/companies/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name UploadAndValidateUserFile
     * @request POST:/api/companies/{companyId}/import-users
     * @secure
     */
    uploadAndValidateUserFile: (
      companyId: number,
      data: {
        ContentType?: string;
        ContentDisposition?: string;
        Headers?: Record<string, string[]>;
        /** @format int64 */
        Length?: number;
        Name?: string;
        FileName?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserImportErrorItem[], ErrorResponse | string>({
        path: `/api/companies/${companyId}/import-users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetImportUserJobs
     * @request GET:/api/companies/{companyId}/import-user-jobs
     * @secure
     */
    getImportUserJobs: (
      companyId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FileImportModelPaginationResult, ErrorResponse | string>({
        path: `/api/companies/${companyId}/import-user-jobs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name GetImportUserJobDetail
     * @request GET:/api/companies/{companyId}/import-user-jobs/{jobId}/details
     * @secure
     */
    getImportUserJobDetail: (
      companyId: number,
      jobId: string,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserImportDetailModelPaginationResult, ErrorResponse | string>({
        path: `/api/companies/${companyId}/import-user-jobs/${jobId}/details`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CronJobTest
     * @name CronJobTestTriggerUserEmailBackgroundJob
     * @request GET:/api/v1/cron-job-test/SendUserBackgroundEmailAlertJob
     * @secure
     */
    cronJobTestTriggerUserEmailBackgroundJob: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/v1/cron-job-test/SendUserBackgroundEmailAlertJob`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email
     * @name SendEmail
     * @request POST:/api/email/send
     * @secure
     */
    sendEmail: (data: SendEmailRequest, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/email/send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email
     * @name AdminSendEmail
     * @request POST:/api/email/admin-send
     * @secure
     */
    adminSendEmail: (data: AminSendMailRequest, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/email/admin-send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventTracking
     * @name SearchEventTrackingService
     * @request POST:/api/event-tracking/search
     * @secure
     */
    searchEventTrackingService: (data: EventTrackingSearchRequest, params: RequestParams = {}) =>
      this.http.request<EventTrackingPaginationResult, ErrorResponse | string>({
        path: `/api/event-tracking/search`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventTracking
     * @name GetEventTrackingMasterData
     * @request GET:/api/event-tracking/masterdata
     * @secure
     */
    getEventTrackingMasterData: (
      query?: {
        event?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<EventTrackingMasterData[], ErrorResponse | string>({
        path: `/api/event-tracking/masterdata`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExternalCalendarEvent
     * @name AdminCreateExternalCalendarEvent
     * @request POST:/api/external-calendar/{bookingId}
     * @secure
     */
    adminCreateExternalCalendarEvent: (
      bookingId: string,
      data: CreateExternalCalendarEventRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/api/external-calendar/${bookingId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExternalCalendarEvent
     * @name GoogleSearchSimilarEvents
     * @request POST:/api/external-calendar/google/search
     * @secure
     */
    googleSearchSimilarEvents: (data: GoogleCalendarSearchQuery, params: RequestParams = {}) =>
      this.http.request<EventEventsExternalCalendarEventSearchResult, ErrorResponse>({
        path: `/api/external-calendar/google/search`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExternalCalendarEvent
     * @name GoogleSearchNext
     * @request POST:/api/external-calendar/google/search/next
     * @secure
     */
    googleSearchNext: (data: GoogleCalendarSearchNextQuery, params: RequestParams = {}) =>
      this.http.request<EventEventsExternalCalendarEventSearchResult, ErrorResponse>({
        path: `/api/external-calendar/google/search/next`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExternalCalendarEvent
     * @name ExternalCalendarLinkBookingEvent
     * @request POST:/api/external-calendar/link
     * @secure
     */
    externalCalendarLinkBookingEvent: (data: ExternalCalendarLinkRequest, params: RequestParams = {}) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/api/external-calendar/link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExternalCalendarEvent
     * @name ExternalCalendarSyncBookingEvent
     * @request POST:/api/external-calendar/sync
     * @secure
     */
    externalCalendarSyncBookingEvent: (data: ExternalCalendarSyncRequest, params: RequestParams = {}) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/api/external-calendar/sync`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExternalCalendarEvent
     * @name AdminAddGoogleCalendarToServiceAccount
     * @request POST:/api/external-calendar/google/add-calendar/{calendarId}
     * @secure
     */
    adminAddGoogleCalendarToServiceAccount: (calendarId: string, params: RequestParams = {}) =>
      this.http.request<CalendarListEntry, ErrorResponse>({
        path: `/api/external-calendar/google/add-calendar/${calendarId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GitBranchingVersion
     * @name GitBranchingVersionGetWisoryVersion
     * @request GET:/api/v1/wisory-backend/git-info
     * @secure
     */
    gitBranchingVersionGetWisoryVersion: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/v1/wisory-backend/git-info`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendarWebHook
     * @name GoogleCalendarWebHookTest
     * @request POST:/api/google-calendar/test/{eventId}
     * @secure
     */
    googleCalendarWebHookTest: (eventId: string, data: string, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/google-calendar/test/${eventId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendarWebHook
     * @name GoogleCalendarWebHookNotifications
     * @request POST:/api/google-calendar/notifications
     * @secure
     */
    googleCalendarWebHookNotifications: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/google-calendar/notifications`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name GetAllInvoices
     * @request GET:/api/invoices
     * @secure
     */
    getAllInvoices: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<InvoiceViewPaginationResult, ErrorResponse>({
        path: `/api/invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name GetInvoiceDetails
     * @request GET:/api/invoices/{invoiceId}
     * @secure
     */
    getInvoiceDetails: (invoiceId: number, params: RequestParams = {}) =>
      this.http.request<InvoiceView, ErrorResponse | ProblemDetails>({
        path: `/api/invoices/${invoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name CompletePaymentForInvoice
     * @request GET:/api/invoices/{invoiceId}/complete-payment
     * @secure
     */
    completePaymentForInvoice: (invoiceId: number, params: RequestParams = {}) =>
      this.http.request<InvoiceView, ErrorResponse | ProblemDetails>({
        path: `/api/invoices/${invoiceId}/complete-payment`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name RejectInvoice
     * @request GET:/api/invoices/{invoiceId}/reject
     * @secure
     */
    rejectInvoice: (invoiceId: number, params: RequestParams = {}) =>
      this.http.request<InvoiceView, ErrorResponse | ProblemDetails>({
        path: `/api/invoices/${invoiceId}/reject`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name ApproveInvoice
     * @request GET:/api/invoices/{invoiceId}/approve
     * @secure
     */
    approveInvoice: (invoiceId: number, params: RequestParams = {}) =>
      this.http.request<InvoiceView, ErrorResponse | ProblemDetails>({
        path: `/api/invoices/${invoiceId}/approve`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name GetInvoiceHistories
     * @request GET:/api/invoices/{invoiceId}/histories
     * @secure
     */
    getInvoiceHistories: (
      invoiceId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<InvoiceViewPaginationResult, ErrorResponse>({
        path: `/api/invoices/${invoiceId}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name GetInvoiceTransactions
     * @request GET:/api/invoices/{invoiceId}/transactions
     * @secure
     */
    getInvoiceTransactions: (
      invoiceId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<TransactionViewPaginationResult, ErrorResponse>({
        path: `/api/invoices/${invoiceId}/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name ExportInvoiceList
     * @request GET:/api/invoices/export
     * @secure
     */
    exportInvoiceList: (
      query?: {
        exporter?: ExporterType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FileExportResult, ErrorResponse>({
        path: `/api/invoices/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locale
     * @name GetAllLocales
     * @request GET:/api/locale
     * @secure
     */
    getAllLocales: (params: RequestParams = {}) =>
      this.http.request<LocaleDto[], ErrorResponse>({
        path: `/api/locale`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name GetMetadata
     * @request GET:/api/metadata/{entityId}/{entityType}
     * @secure
     */
    getMetadata: (entityId: number, entityType: string, params: RequestParams = {}) =>
      this.http.request<MetadataView[], ErrorResponse | string>({
        path: `/api/metadata/${entityId}/${entityType}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name CreateOrUpdateMetadata
     * @request POST:/api/metadata/{entityId}/{entityType}
     * @secure
     */
    createOrUpdateMetadata: (
      entityId: number,
      entityType: string,
      data: CreateOrUpdateMetadataView,
      params: RequestParams = {}
    ) =>
      this.http.request<MetadataView, ErrorResponse | string>({
        path: `/api/metadata/${entityId}/${entityType}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSet
     * @name GetDisplayTypes
     * @request GET:/api/metadata-set/display-types
     * @secure
     */
    getDisplayTypes: (params: RequestParams = {}) =>
      this.http.request<string[], ErrorResponse | string>({
        path: `/api/metadata-set/display-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSet
     * @name GetMetadataSetWithOptionsById
     * @request GET:/api/metadata-set/{setId}
     * @secure
     */
    getMetadataSetWithOptionsById: (setId: number, params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/metadata-set/${setId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSet
     * @name GetMetadataSetByEntityType
     * @request GET:/api/metadata-set/entity-type/{entityType}
     * @secure
     */
    getMetadataSetByEntityType: (entityType: string, params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/metadata-set/entity-type/${entityType}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSet
     * @name CreateMetadataSet
     * @request POST:/api/metadata-set
     * @secure
     */
    createMetadataSet: (data: CreateMetadataSetView, params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/metadata-set`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSet
     * @name UpdateMetadataSet
     * @request PUT:/api/metadata-set/{id}
     * @secure
     */
    updateMetadataSet: (id: number, data: UpdateMetadataSetView, params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/metadata-set/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSet
     * @name DeleteMetadataSet
     * @request DELETE:/api/metadata-set/{id}
     * @secure
     */
    deleteMetadataSet: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse | string>({
        path: `/api/metadata-set/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSetOption
     * @name GetMetadataSetOptions
     * @request GET:/api/metadata-set/{setId}/options
     * @secure
     */
    getMetadataSetOptions: (setId: number, params: RequestParams = {}) =>
      this.http.request<MetadataSetOptionView[], ErrorResponse | string>({
        path: `/api/metadata-set/${setId}/options`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSetOption
     * @name CreateMetadataSetOption
     * @request POST:/api/metadata-set/{setId}/options
     * @secure
     */
    createMetadataSetOption: (setId: number, data: CreateMetadataSetOptionView, params: RequestParams = {}) =>
      this.http.request<MetadataSetOptionView, ErrorResponse | string>({
        path: `/api/metadata-set/${setId}/options`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSetOption
     * @name GetMetadataSetOption
     * @request GET:/api/metadata-set/{setId}/options/{optionId}
     * @secure
     */
    getMetadataSetOption: (setId: number, optionId: number, params: RequestParams = {}) =>
      this.http.request<MetadataSetOptionView, ErrorResponse | string>({
        path: `/api/metadata-set/${setId}/options/${optionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSetOption
     * @name UpdateMetadataSetOption
     * @request PUT:/api/metadata-set/{setId}/options/{optionId}
     * @secure
     */
    updateMetadataSetOption: (
      setId: number,
      optionId: number,
      data: UpdateMetadataSetOptionView,
      params: RequestParams = {}
    ) =>
      this.http.request<MetadataSetOptionView, ErrorResponse | string>({
        path: `/api/metadata-set/${setId}/options/${optionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetadataSetOption
     * @name DeleteMetadataSetOption
     * @request DELETE:/api/metadata-set/{setId}/options/{optionId}
     * @secure
     */
    deleteMetadataSetOption: (setId: number, optionId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse | string>({
        path: `/api/metadata-set/${setId}/options/${optionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Package
     * @name PackageOrder
     * @request POST:/api/package/orders
     * @secure
     */
    packageOrder: (data: AddPackageOrderView, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse>({
        path: `/api/package/orders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Package
     * @name GetAllPackageOrders
     * @request GET:/api/package/orders
     * @secure
     */
    getAllPackageOrders: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PackageOrderViewPaginationResult, ErrorResponse>({
        path: `/api/package/orders`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Package
     * @name GetPackageOrderDetails
     * @request GET:/api/package/orders/{orderId}
     * @secure
     */
    getPackageOrderDetails: (orderId: number, params: RequestParams = {}) =>
      this.http.request<PackageOrderView, ErrorResponse | ProblemDetails>({
        path: `/api/package/orders/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Package
     * @name ExportPackageOrderList
     * @request GET:/api/package/orders/export
     * @secure
     */
    exportPackageOrderList: (
      query?: {
        exporter?: ExporterType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<IFileExportResult, ErrorResponse>({
        path: `/api/package/orders/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCreate
     * @request POST:/api/payment/booking/checkout
     * @secure
     */
    paymentCreate: (data: CreateBookingCalendarEventOnlinePaymentView, params: RequestParams = {}) =>
      this.http.request<InitOnlinePaymentResponseView, ErrorResponse>({
        path: `/api/payment/booking/checkout`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCreateBookingInvoice
     * @request POST:/api/payment/booking/invoice
     * @secure
     */
    paymentCreateBookingInvoice: (data: CreateBookingInvoicePaymentView, params: RequestParams = {}) =>
      this.http.request<InvoiceView, ErrorResponse>({
        path: `/api/payment/booking/invoice`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentWebHook
     * @name PaymentWebHookStripeWebhook
     * @request POST:/api/payment/webhook/stripe
     * @secure
     */
    paymentWebHookStripeWebhook: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/payment/webhook/stripe`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SendGrid
     * @name SendGridHandleSendGridWebhookEvent
     * @request POST:/api/SendGrid
     * @secure
     */
    sendGridHandleSendGridWebhookEvent: (data: any[], params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/api/SendGrid`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SendGrid
     * @name GetEmailStatusForBooking
     * @request POST:/api/SendGrid/bookingsSyncStatus
     * @secure
     */
    getEmailStatusForBooking: (data: GetBookingsSyncEmailStatusRequest, params: RequestParams = {}) =>
      this.http.request<BookingEmailStatusPaginationResult, ErrorResponse>({
        path: `/api/SendGrid/bookingsSyncStatus`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transaction
     * @name GetAllTransactions
     * @request GET:/api/transactions
     * @secure
     */
    getAllTransactions: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<StripeCardPaymentTransactionViewPaginationResult, ErrorResponse>({
        path: `/api/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transaction
     * @name GetTransaction
     * @request GET:/api/transactions/{transactionId}
     * @secure
     */
    getTransaction: (transactionId: number, params: RequestParams = {}) =>
      this.http.request<StripeCardPaymentTransactionView, ErrorResponse>({
        path: `/api/transactions/${transactionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transaction
     * @name GetTransactionHistories
     * @request GET:/api/transactions/{transactionId}/histories
     * @secure
     */
    getTransactionHistories: (
      transactionId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<StripeCardPaymentTransactionViewPaginationResult, ErrorResponse>({
        path: `/api/transactions/${transactionId}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transaction
     * @name ExportTransactionList
     * @request GET:/api/transactions/export
     * @secure
     */
    exportTransactionList: (
      query?: {
        exporter?: ExporterType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ErrorResponse>({
        path: `/api/transactions/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserById
     * @request GET:/api/users/{userId}
     * @secure
     */
    getUserById: (userId: number, params: RequestParams = {}) =>
      this.http.request<IdentityUserView, ErrorResponse | string>({
        path: `/api/users/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateUser
     * @request PUT:/api/users/{userId}
     * @secure
     */
    updateUser: (userId: number, data: UpdateUserView, params: RequestParams = {}) =>
      this.http.request<IdentityUserView, ErrorResponse | string>({
        path: `/api/users/${userId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserSessions
     * @request GET:/api/users/{userId}/sessions
     * @secure
     */
    getUserSessions: (userId: number, params: RequestParams = {}) =>
      this.http.request<AdvisorProfileView, ErrorResponse | string>({
        path: `/api/users/${userId}/sessions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUsers
     * @request GET:/api/users
     * @secure
     */
    getUsers: (
      query?: {
        /** @format int32 */
        currentPage?: number;
        /** @format int32 */
        pageSize?: number;
        companyName?: string;
        roleName?: string;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<IdentityUserViewPaginationResult, ErrorResponse | string>({
        path: `/api/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CreateUser
     * @request POST:/api/users
     * @secure
     */
    createUser: (data: CreateUserView, params: RequestParams = {}) =>
      this.http.request<IdentityUserView, ErrorResponse | string>({
        path: `/api/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserByEmails
     * @request GET:/api/users/email
     * @secure
     */
    getUserByEmails: (
      query: {
        userEmail: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<IdentityUserView, ErrorResponse | string>({
        path: `/api/users/email`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateUserPasswordByAdmin
     * @request PUT:/api/users/{userId}/admin-change-password
     * @secure
     */
    updateUserPasswordByAdmin: (userId: number, data: UpdatePasswordByAdminView, params: RequestParams = {}) =>
      this.http.request<IdentityUserView, ErrorResponse | string>({
        path: `/api/users/${userId}/admin-change-password`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateUserName
     * @request PUT:/api/users/{userId}/username
     * @secure
     */
    updateUserName: (userId: number, data: UpdateUserNameView, params: RequestParams = {}) =>
      this.http.request<IdentityUserView, ErrorResponse | string>({
        path: `/api/users/${userId}/username`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name AddRolesToUser
     * @request POST:/api/users/{userId}/roles
     * @secure
     */
    addRolesToUser: (userId: number, data: string[], params: RequestParams = {}) =>
      this.http.request<string[], ErrorResponse | string>({
        path: `/api/users/${userId}/roles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RemoveUserRoles
     * @request DELETE:/api/users/{userId}/roles
     * @secure
     */
    removeUserRoles: (userId: number, data: string[], params: RequestParams = {}) =>
      this.http.request<string[], ErrorResponse | string>({
        path: `/api/users/${userId}/roles`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserRoles
     * @request GET:/api/users/{userId}/roles
     * @secure
     */
    getUserRoles: (userId: number, params: RequestParams = {}) =>
      this.http.request<string[], ErrorResponse | string>({
        path: `/api/users/${userId}/roles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SearchUsers
     * @request GET:/api/users/search
     * @secure
     */
    searchUsers: (
      query?: {
        /** @format int32 */
        currentPage?: number;
        /** @format int32 */
        pageSize?: number;
        role?: string;
        filter?: string;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<SearchIdentityUserViewPaginationResult, ErrorResponse | string>({
        path: `/api/users/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SearchFailedLoginUsers
     * @request GET:/api/users/failed-login
     * @secure
     */
    searchFailedLoginUsers: (
      query?: {
        /** @format int32 */
        currentPage?: number;
        /** @format int32 */
        pageSize?: number;
        email?: string;
        filter?: string;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FailedLoginUserResponsePaginationResult, ErrorResponse | string>({
        path: `/api/users/failed-login`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetEntityType
     * @request GET:/api/users/entity-type
     * @secure
     */
    getEntityType: (params: RequestParams = {}) =>
      this.http.request<EntityTypeView, ErrorResponse | string>({
        path: `/api/users/entity-type`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ActivateUser
     * @request POST:/api/users/{userId}/activate
     * @secure
     */
    activateUser: (userId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse | string>({
        path: `/api/users/${userId}/activate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name DeactivateUser
     * @request POST:/api/users/{userId}/deactivate
     * @secure
     */
    deactivateUser: (userId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse | string>({
        path: `/api/users/${userId}/deactivate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetExportedCsvOfUserOverview
     * @request GET:/api/users/export
     * @secure
     */
    getExportedCsvOfUserOverview: (
      query?: {
        exporter?: ExporterType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FileExportResult, ErrorResponse>({
        path: `/api/users/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserEmailStatus
     * @request GET:/api/users/{userId}/email-status
     * @secure
     */
    getUserEmailStatus: (
      userId: number,
      query?: {
        /** @format int32 */
        currentPage?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserEmailStatusPaginationResult, ErrorResponse>({
        path: `/api/users/${userId}/email-status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name GetUserMetadataSetWithOptions
     * @request GET:/api/user-metadata/metadata-set
     * @secure
     */
    getUserMetadataSetWithOptions: (params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/user-metadata/metadata-set`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name CreateUserMetadataSet
     * @request POST:/api/user-metadata/metadata-set
     * @secure
     */
    createUserMetadataSet: (data: CreateUserMetadataSetView, params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/user-metadata/metadata-set`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name GetUserMetadataSetWithOptionsById
     * @request GET:/api/user-metadata/metadata-set/{setId}
     * @secure
     */
    getUserMetadataSetWithOptionsById: (setId: number, params: RequestParams = {}) =>
      this.http.request<MetadataSetView, ErrorResponse | string>({
        path: `/api/user-metadata/metadata-set/${setId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name GetUserMetadataSetWithOptionsAndValues
     * @request GET:/api/user-metadata/{userId}/metadata-set
     * @secure
     */
    getUserMetadataSetWithOptionsAndValues: (userId: number, params: RequestParams = {}) =>
      this.http.request<MetadataSetView[], ErrorResponse | string>({
        path: `/api/user-metadata/${userId}/metadata-set`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name GetUserMetadataSetWithOptionsAndValuesById
     * @request GET:/api/user-metadata/{userId}/metadata-set/{setId}
     * @secure
     */
    getUserMetadataSetWithOptionsAndValuesById: (userId: number, setId: number, params: RequestParams = {}) =>
      this.http.request<MetadataSetView, ErrorResponse | string>({
        path: `/api/user-metadata/${userId}/metadata-set/${setId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name CreateUserMetadataSetOption
     * @request POST:/api/user-metadata/metadata-set/{setId}/options
     * @secure
     */
    createUserMetadataSetOption: (setId: number, data: CreateMetadataSetOptionView, params: RequestParams = {}) =>
      this.http.request<MetadataSetOptionView, ErrorResponse | string>({
        path: `/api/user-metadata/metadata-set/${setId}/options`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name CreateOrUpdateUserMetadataSetValue
     * @request POST:/api/user-metadata/{userId}/metadata-set/{setId}/values
     * @secure
     */
    createOrUpdateUserMetadataSetValue: (
      userId: number,
      setId: number,
      data: CreateOrUpdateUserMetadataView,
      params: RequestParams = {}
    ) =>
      this.http.request<MetadataSetView, ErrorResponse | string>({
        path: `/api/user-metadata/${userId}/metadata-set/${setId}/values`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name UpdateUserMetadataSetOption
     * @request PUT:/api/user-metadata/metadata-set/{setId}/options/{optionId}
     * @secure
     */
    updateUserMetadataSetOption: (
      setId: number,
      optionId: number,
      data: UpdateMetadataSetOptionView,
      params: RequestParams = {}
    ) =>
      this.http.request<MetadataSetOptionView, ErrorResponse | string>({
        path: `/api/user-metadata/metadata-set/${setId}/options/${optionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserMetadataSet
     * @name DeleteUserMetadataSetOption
     * @request DELETE:/api/user-metadata/metadata-set/{setId}/options/{optionId}
     * @secure
     */
    deleteUserMetadataSetOption: (setId: number, optionId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorResponse | string>({
        path: `/api/user-metadata/metadata-set/${setId}/options/${optionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validation
     * @name ValidatePhoneNumber
     * @request POST:/api/validation/phone-number
     * @secure
     */
    validatePhoneNumber: (data: PhoneNumberValidateObject, params: RequestParams = {}) =>
      this.http.request<ValidationResultObject, ErrorResponse>({
        path: `/api/validation/phone-number`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validation
     * @name ValidateEmail
     * @request POST:/api/validation/email
     * @secure
     */
    validateEmail: (data: EmailValidateObject, params: RequestParams = {}) =>
      this.http.request<ValidationResultObject, ErrorResponse>({
        path: `/api/validation/email`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  advisorAvailabilityImports = {
    /**
     * No description
     *
     * @tags AdvisorAvailabilityImport
     * @name GetAllAdvisorAvailabilityImportDtoForAdmin
     * @request GET:/advisorAvailabilityImports
     * @secure
     */
    getAllAdvisorAvailabilityImportDtoForAdmin: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AdvisorAvailabilityImportDtoPaginationResult, ErrorResponse | string>({
        path: `/advisorAvailabilityImports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvisorAvailabilityImport
     * @name BulkImportAvailability
     * @request PUT:/advisorAvailabilityImports/bulk-import
     * @secure
     */
    bulkImportAvailability: (data: ImportAdvisorAvailabilityCommand[], params: RequestParams = {}) =>
      this.http.request<AdvisorAvailabilityImportDto[], ErrorResponse | string>({
        path: `/advisorAvailabilityImports/bulk-import`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvisorAvailabilityImport
     * @name ImportAvailability
     * @request PUT:/advisorAvailabilityImports/import
     * @secure
     */
    importAvailability: (data: ImportAdvisorAvailabilityCommand, params: RequestParams = {}) =>
      this.http.request<AdvisorAvailabilityImportDto, ErrorResponse | string>({
        path: `/advisorAvailabilityImports/import`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvisorAvailabilityImport
     * @name UnapprovedImportAvailability
     * @request PUT:/advisorAvailabilityImports/unapproved
     * @secure
     */
    unapprovedImportAvailability: (data: UnapprovedImportAdvisorAvailabilityCommand, params: RequestParams = {}) =>
      this.http.request<UnapprovedImportAdvisorAvailabilityResponse, ErrorResponse | string>({
        path: `/advisorAvailabilityImports/unapproved`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvisorAvailabilityImport
     * @name BulkUnapprovedImportAvailability
     * @request PUT:/advisorAvailabilityImports/bulk/unapproved
     * @secure
     */
    bulkUnapprovedImportAvailability: (
      data: UnapprovedImportAdvisorAvailabilitiesCommand,
      params: RequestParams = {}
    ) =>
      this.http.request<UnapprovedImportAdvisorAvailabilityResponse[], ErrorResponse | string>({
        path: `/advisorAvailabilityImports/bulk/unapproved`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  appointmentAvailabilities = {
    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name GetAllAppointmentAvailabilitiesForAdmin
     * @request GET:/appointmentAvailabilities
     * @secure
     */
    getAllAppointmentAvailabilitiesForAdmin: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int64 */
        filteredAdvisorId?: number;
        periodFromDate?: string;
        periodToDate?: string;
        includedDeletedAppointments?: boolean;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AppointmentAvailabilityDtoPaginationResult, ErrorResponse>({
        path: `/appointmentAvailabilities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name CreateAppointmentAvailability
     * @request POST:/appointmentAvailabilities
     * @secure
     */
    createAppointmentAvailability: (data: CreateAppointmentAvailabilityView, params: RequestParams = {}) =>
      this.http.request<AppointmentAvailabilityDto, ErrorResponse>({
        path: `/appointmentAvailabilities`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name DeleteAppointmentAvailability
     * @request DELETE:/appointmentAvailabilities
     * @secure
     */
    deleteAppointmentAvailability: (
      query?: {
        /** @format int32 */
        id?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/appointmentAvailabilities`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name ExportAppointmentAvailability
     * @request GET:/appointmentAvailabilities/export
     * @secure
     */
    exportAppointmentAvailability: (
      query?: {
        exporter?: ExporterType;
        /** @format int64 */
        filteredAdvisorId?: number;
        periodFromDate?: string;
        periodToDate?: string;
        includedDeletedAppointments?: boolean;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/appointmentAvailabilities/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name GetAppointmentAvailabilityHistories
     * @request GET:/appointmentAvailabilities/{advisorAvailabilityId}/histories
     * @secure
     */
    getAppointmentAvailabilityHistories: (
      advisorAvailabilityId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AdvisorAvailabilityHistoryViewPaginationResult, ErrorResponse>({
        path: `/appointmentAvailabilities/${advisorAvailabilityId}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name GetAllBookingItemOfCurrentAdvisorAvailabilityId
     * @request GET:/appointmentAvailabilities/{advisorAvailabilityId}/booking-histories
     * @secure
     */
    getAllBookingItemOfCurrentAdvisorAvailabilityId: (
      advisorAvailabilityId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDtoPaginationResult, ErrorResponse>({
        path: `/appointmentAvailabilities/${advisorAvailabilityId}/booking-histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name UpdatePriceForSession
     * @request PUT:/appointmentAvailabilities/{id}/price
     * @secure
     */
    updatePriceForSession: (
      id: number,
      data: UpdateAppointmentAvailabilitySessionPriceView,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ErrorResponse>({
        path: `/appointmentAvailabilities/${id}/price`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name UpdateAppointmentAvailability
     * @request PUT:/appointmentAvailabilities/{id}
     * @secure
     */
    updateAppointmentAvailability: (id: number, data: UpdateAppointmentAvailabilityView, params: RequestParams = {}) =>
      this.http.request<AppointmentAvailabilityDto, ErrorResponse>({
        path: `/appointmentAvailabilities/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name GetAppointmentAvailabilityDetails
     * @request GET:/appointmentAvailabilities/{id}
     * @secure
     */
    getAppointmentAvailabilityDetails: (id: number, params: RequestParams = {}) =>
      this.http.request<AppointmentAvailabilityDto, ErrorResponse | ProblemDetails>({
        path: `/appointmentAvailabilities/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name GetAdvisorOverlappingAppointmentAvailability
     * @request POST:/appointmentAvailabilities/get-advisor-overlapping-slots
     * @secure
     */
    getAdvisorOverlappingAppointmentAvailability: (data: CheckOverlappedSlot, params: RequestParams = {}) =>
      this.http.request<AppointmentAvailabilityDto[], ErrorResponse>({
        path: `/appointmentAvailabilities/get-advisor-overlapping-slots`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentAvailabilities
     * @name GetExistingAppointmentAvailability
     * @request POST:/appointmentAvailabilities/get-existing-slot
     * @secure
     */
    getExistingAppointmentAvailability: (data: GetExistingSlot, params: RequestParams = {}) =>
      this.http.request<AppointmentAvailabilityDto, ErrorResponse>({
        path: `/appointmentAvailabilities/get-existing-slot`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  availabilityFormParseResults = {
    /**
     * No description
     *
     * @tags AvailabilityFormParseResult
     * @name GetAllAvailabilityFormParseResultDtoForAdmin
     * @request GET:/availabilityFormParseResults
     * @secure
     */
    getAllAvailabilityFormParseResultDtoForAdmin: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AvailabilityFormParseResultDtoPaginationResult, ErrorResponse | string>({
        path: `/availabilityFormParseResults`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AvailabilityFormParseResult
     * @name GetAdvisorAvailabilityImportDtoPerForm
     * @request GET:/availabilityFormParseResults/{id}/availabilities
     * @secure
     */
    getAdvisorAvailabilityImportDtoPerForm: (
      id: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AdvisorAvailabilityImportDtoPaginationResult, ErrorResponse | string>({
        path: `/availabilityFormParseResults/${id}/availabilities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  calendarEvents = {
    /**
     * No description
     *
     * @tags BookingCalendarEventHistory
     * @name GetBookingCalendarEventHistory
     * @request GET:/calendarEvents/{bookingCalendarEventId}/histories
     * @secure
     */
    getBookingCalendarEventHistory: (
      bookingCalendarEventId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventHistoryViewPaginationResult, ErrorResponse | string>({
        path: `/calendarEvents/${bookingCalendarEventId}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingCalendarEventHistory
     * @name GetBookingCalendarEventHistoryChangedByStatus
     * @request GET:/calendarEvents/{bookingCalendarEventId}/histories/status
     * @secure
     */
    getBookingCalendarEventHistoryChangedByStatus: (
      bookingCalendarEventId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventHistoryViewPaginationResult, ErrorResponse | string>({
        path: `/calendarEvents/${bookingCalendarEventId}/histories/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingCalendarEventHistory
     * @name GetExportedCsvOfBookingCalendarEventHistory
     * @request GET:/calendarEvents/{bookingCalendarEventId}/histories/export
     * @secure
     */
    getExportedCsvOfBookingCalendarEventHistory: (
      bookingCalendarEventId: number,
      query?: {
        exporter?: ExporterType;
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<File, ErrorResponse | string>({
        path: `/calendarEvents/${bookingCalendarEventId}/histories/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetMyCalendarEvents
     * @request GET:/calendarEvents
     * @secure
     */
    getMyCalendarEvents: (
      query?: {
        periodStartDate?: string;
        periodEndDate?: string;
        includedCancelledEvent?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDto[], ErrorResponse>({
        path: `/calendarEvents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name CreateCalendarEvent
     * @request POST:/calendarEvents
     * @secure
     */
    createCalendarEvent: (data: CreateBookingCalendarEventViewFromBackOffice, params: RequestParams = {}) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/calendarEvents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetVideoSessionLinks
     * @request GET:/calendarEvents/{id}/session-links
     * @secure
     */
    getVideoSessionLinks: (id: number, params: RequestParams = {}) =>
      this.http.request<BookingCalendarSessionLinkResponse[], ErrorResponse>({
        path: `/calendarEvents/${id}/session-links`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetCalendarEventDetailForRebuy
     * @request GET:/calendarEvents/{calendarEventId}/rebuy
     * @secure
     */
    getCalendarEventDetailForRebuy: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<PublicRebuyBookingCalendarView, ErrorResponse | string>({
        path: `/calendarEvents/${calendarEventId}/rebuy`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name CreateRebookCalendarEvent
     * @request POST:/calendarEvents/{calendarEventId}/rebuy
     * @secure
     */
    createRebookCalendarEvent: (
      calendarEventId: number,
      data: RebuyBookingCalendarEventRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<RebuyBookingCalendarEventResponse, ErrorResponse | string>({
        path: `/calendarEvents/${calendarEventId}/rebuy`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name UpdateBookingCalendarEventLocale
     * @request PUT:/calendarEvents/{calendarEventId}/locale
     * @secure
     */
    updateBookingCalendarEventLocale: (
      calendarEventId: number,
      query?: {
        requestedLocale?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/locale`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name CheckEventCanBeCancelled
     * @request GET:/calendarEvents/{calendarEventId}/canBeCancelled
     * @secure
     */
    checkEventCanBeCancelled: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<CalendarEventCancellationView, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/canBeCancelled`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name AdminCreateCalendarEvent
     * @request POST:/calendarEvents/adminCreate
     * @secure
     */
    adminCreateCalendarEvent: (data: CreateBookingCalendarEventViewFromBackOffice, params: RequestParams = {}) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/calendarEvents/adminCreate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name VerifyCalendarEvent
     * @request PUT:/calendarEvents/{calendarEventId}/verify
     * @secure
     */
    verifyCalendarEvent: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/verify`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name PostponeCalendarEvent
     * @request PUT:/calendarEvents/{calendarEventId}/postpone
     * @secure
     */
    postponeCalendarEvent: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/postpone`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name UpdateCalendarEvent
     * @request PATCH:/calendarEvents/{calendarEventId}
     * @secure
     */
    updateCalendarEvent: (calendarEventId: number, data: Operation[], params: RequestParams = {}) =>
      this.http.request<UpdateCalendarEventResponse, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetBookingCalendarEventDetails
     * @request GET:/calendarEvents/{calendarEventId}
     * @secure
     */
    getBookingCalendarEventDetails: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<BookingCalendarEventDetailResponse, ErrorResponse | ProblemDetails>({
        path: `/calendarEvents/${calendarEventId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name RescheduleCalendarEvent
     * @request POST:/calendarEvents/{calendarEventId}/reschedule
     * @secure
     */
    rescheduleCalendarEvent: (
      calendarEventId: number,
      query?: {
        /** @format int64 */
        userId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/reschedule`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetAll
     * @request GET:/calendarEvents/all
     * @secure
     */
    getAll: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int64 */
        filteredAdvisorId?: number;
        /** @format int64 */
        filterUserId?: number;
        /** @format int64 */
        filteredCustomerId?: number;
        periodStartDate?: string;
        periodEndDate?: string;
        includedCancelledEvent?: boolean;
        bookingCalendarEventType?: BookingCalendarEventType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDtoPaginationResult, ErrorResponse>({
        path: `/calendarEvents/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetExportedCsvOfCalendarEvent
     * @request GET:/calendarEvents/export
     * @secure
     */
    getExportedCsvOfCalendarEvent: (
      query?: {
        exporter?: ExporterType;
        /** @format int64 */
        filteredAdvisorId?: number;
        /** @format int64 */
        filteredCustomerId?: number;
        periodStartDate?: string;
        periodEndDate?: string;
        includedCancelledEvent?: boolean;
        dynamicFilters?: string;
        bookingCalendarEventType?: BookingCalendarEventType;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<File, ErrorResponse | string>({
        path: `/calendarEvents/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name CheckCalendarEventCanBeRebook
     * @request GET:/calendarEvents/{calendarEventId}/canberebooked
     * @secure
     */
    checkCalendarEventCanBeRebook: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<CheckCalendarEventRebookView, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/canberebooked`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name RedirectToSessionRoomLink
     * @request GET:/calendarEvents/{id}/session-link
     * @secure
     */
    redirectToSessionRoomLink: (
      id: number,
      query?: {
        isWisoryTestPassed?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${id}/session-link`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name SearchEventsDeltaLogs
     * @request POST:/calendarEvents/events-delta-logs
     * @secure
     */
    searchEventsDeltaLogs: (data: SearchEventDeltaRequest, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse | JobExecutionSuccessPaginationResult>({
        path: `/calendarEvents/events-delta-logs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name RebuyCalendarEventVerifyOverlappingTime
     * @request POST:/calendarEvents/{calendarEventId}/rebuy/verify
     * @secure
     */
    rebuyCalendarEventVerifyOverlappingTime: (
      calendarEventId: number,
      data: RebuyBookingCalendarEventAvailableSlotCheckRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<boolean, ErrorResponse | string>({
        path: `/calendarEvents/${calendarEventId}/rebuy/verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name RebookCalendarEvent
     * @request PUT:/calendarEvents/{calendarEventId}/rebook
     * @secure
     */
    rebookCalendarEvent: (calendarEventId: number, data: RebookCalendarEventView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/rebook`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name RebookedCalendarEventLogs
     * @request GET:/calendarEvents/{calendarEventId}/rebooked-logs
     * @secure
     */
    rebookedCalendarEventLogs: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<RebookedCalendarEventLogView, ErrorResponse | ProblemDetails>({
        path: `/calendarEvents/${calendarEventId}/rebooked-logs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name RebookedCalendarEventsLogs
     * @request POST:/calendarEvents/rebooked-logs
     * @secure
     */
    rebookedCalendarEventsLogs: (data: GetRebookedCalendarEventsLogViewQuery, params: RequestParams = {}) =>
      this.http.request<RebookedCalendarEventLogView[], ErrorResponse>({
        path: `/calendarEvents/rebooked-logs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name GetAllCalendarEventStatus
     * @request GET:/calendarEvents/statuses
     * @secure
     */
    getAllCalendarEventStatus: (params: RequestParams = {}) =>
      this.http.request<BookingCalendarEventStatusResponse[], ErrorResponse | ProblemDetails>({
        path: `/calendarEvents/statuses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name WorkflowStates
     * @request GET:/calendarEvents/workflow/states
     * @secure
     */
    workflowStates: (params: RequestParams = {}) =>
      this.http.request<string, ErrorResponse | ProblemDetails>({
        path: `/calendarEvents/workflow/states`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name WorkflowStatesForSpecificCalendarEvent
     * @request GET:/calendarEvents/{calendarEventId}/workflow/states
     * @secure
     */
    workflowStatesForSpecificCalendarEvent: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<string, ErrorResponse | ProblemDetails>({
        path: `/calendarEvents/${calendarEventId}/workflow/states`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name CancelCalendarEvent
     * @request PUT:/calendarEvents/{calendarEventId}/cancel
     * @secure
     */
    cancelCalendarEvent: (calendarEventId: number, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/cancel`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name AdminCancelCalendarEvent
     * @request PUT:/calendarEvents/{calendarEventId}/adminCancel
     * @secure
     */
    adminCancelCalendarEvent: (
      calendarEventId: number,
      query?: {
        isRefundCoin?: boolean;
        isLateCancellation?: boolean;
        forcedCancelWithoutBeingCharged?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/adminCancel`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarEvent
     * @name TransitCalendarEventState
     * @request PUT:/calendarEvents/{calendarEventId}/transit-state/{status}
     * @secure
     */
    transitCalendarEventState: (
      calendarEventId: number,
      status: BookingCalendarEventStatus,
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventDto, ErrorResponse>({
        path: `/calendarEvents/${calendarEventId}/transit-state/${status}`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  calendarAvailability = {
    /**
     * No description
     *
     * @tags CalendarAvailability
     * @name GetAvailableAppointments
     * @request GET:/calendarAvailability/{advisorId}
     * @secure
     */
    getAvailableAppointments: (
      advisorId: number,
      query?: {
        periodFromDate?: string;
        periodToDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PublicAppointmentAvailabilityView[], ErrorResponse>({
        path: `/calendarAvailability/${advisorId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarAvailability
     * @name GetExportAvailableAppointments
     * @request GET:/calendarAvailability/{advisorId}/export
     * @secure
     */
    getExportAvailableAppointments: (
      advisorId: number,
      query?: {
        exporter?: ExporterType;
        periodFromDate?: string;
        periodToDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/calendarAvailability/${advisorId}/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  emailTemplates = {
    /**
     * No description
     *
     * @tags EmailTemplate
     * @name AddEmailTemplate
     * @request POST:/email-templates
     * @secure
     */
    addEmailTemplate: (data: EmailTemplateView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/email-templates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name GetAllEmailTemplates
     * @request GET:/email-templates
     * @secure
     */
    getAllEmailTemplates: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
        isIncludedDeletedItems?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<EmailTemplateViewPaginationResult, ErrorResponse>({
        path: `/email-templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name RestoreEmailTemplateFromHistory
     * @request PUT:/email-templates/{id}/restore
     * @secure
     */
    restoreEmailTemplateFromHistory: (
      id: number,
      query?: {
        /** @format int64 */
        restoreTemplateVersionId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/email-templates/${id}/restore`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name GetHistories
     * @request GET:/email-templates/{id}/histories
     * @secure
     */
    getHistories: (
      id: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<EmailTemplateHistoryViewPaginationResult, ErrorResponse>({
        path: `/email-templates/${id}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name GetEmailTemplateFromId
     * @request GET:/email-templates/{id}
     * @secure
     */
    getEmailTemplateFromId: (id: number, params: RequestParams = {}) =>
      this.http.request<EmailTemplateView, ErrorResponse>({
        path: `/email-templates/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name UpdateEmailTemplate
     * @request PUT:/email-templates/{id}
     * @secure
     */
    updateEmailTemplate: (id: number, data: EmailTemplateView, params: RequestParams = {}) =>
      this.http.request<EmailTemplateView, ErrorResponse>({
        path: `/email-templates/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name DeleteEmailTemplate
     * @request DELETE:/email-templates/{id}
     * @secure
     */
    deleteEmailTemplate: (id: number, params: RequestParams = {}) =>
      this.http.request<EmailTemplateView, ErrorResponse>({
        path: `/email-templates/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name GetEmailTemplateFromName
     * @request GET:/email-templates/{name}
     * @secure
     */
    getEmailTemplateFromName: (name: string, params: RequestParams = {}) =>
      this.http.request<EmailTemplateView, ErrorResponse>({
        path: `/email-templates/${name}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name TestSendMail
     * @request POST:/email-templates/test
     * @secure
     */
    testSendMail: (data: SendMailView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/email-templates/test`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name TestRenderEmailTemplateMjml
     * @request POST:/email-templates/mjml/template
     * @secure
     */
    testRenderEmailTemplateMjml: (data: MjmlModelTest, params: RequestParams = {}) =>
      this.http.request<IEmailContent, ErrorResponse>({
        path: `/email-templates/mjml/template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name Preview
     * @request POST:/email-templates/preview
     * @secure
     */
    preview: (data: EmailPreviewRequestView, params: RequestParams = {}) =>
      this.http.request<IEmailContent, ErrorResponse>({
        path: `/email-templates/preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name PreviewByTemplate
     * @request POST:/email-templates/preview-by-template
     * @secure
     */
    previewByTemplate: (data: EmailPreviewByTemplateRequestView, params: RequestParams = {}) =>
      this.http.request<IEmailContent, ErrorResponse>({
        path: `/email-templates/preview-by-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailTemplate
     * @name EmailTemplateTriggerUserBackgroundEmail
     * @request POST:/email-templates/test/user-background/{bookingId}/trigger
     * @secure
     */
    emailTemplateTriggerUserBackgroundEmail: (
      bookingId: number,
      query?: {
        backgroundEmailEnum?: UserBackgroundEmailEnum;
        locale?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<SendingCustomerExperienceToAdvisorResponse, ErrorResponse>({
        path: `/email-templates/test/user-background/${bookingId}/trigger`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  enums = {
    /**
     * No description
     *
     * @tags Enum
     * @name GetUnitEnumDefinition
     * @request GET:/Enums/Unit
     * @secure
     */
    getUnitEnumDefinition: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/Enums/Unit`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  googleEventSync = {
    /**
     * No description
     *
     * @tags GoogleCalendarEventSync
     * @name GetAllGoogleCalendarEventSyncStatus
     * @request GET:/googleEventSync
     * @secure
     */
    getAllGoogleCalendarEventSyncStatus: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GoogleCalendarEventSyncViewPaginationResult, ErrorResponse>({
        path: `/googleEventSync`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendarEventSync
     * @name GetGoogleCalendarEventSyncDetails
     * @request GET:/googleEventSync/{id}
     * @secure
     */
    getGoogleCalendarEventSyncDetails: (id: number, params: RequestParams = {}) =>
      this.http.request<GoogleCalendarEventSyncView, ErrorResponse>({
        path: `/googleEventSync/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendarEventSync
     * @name GetSyncStatusForAvailability
     * @request POST:/googleEventSync/availabilitiesSyncStatus
     * @secure
     */
    getSyncStatusForAvailability: (data: GetAvailabilitiesSyncStatusRequest, params: RequestParams = {}) =>
      this.http.request<GoogleCalendarEventSyncView[], ErrorResponse>({
        path: `/googleEventSync/availabilitiesSyncStatus`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendarEventSync
     * @name GetSyncStatusForBooking
     * @request POST:/googleEventSync/bookingsSyncStatus
     * @secure
     */
    getSyncStatusForBooking: (data: GetBookingsSyncStatusRequest, params: RequestParams = {}) =>
      this.http.request<GoogleCalendarEventSyncView[], ErrorResponse>({
        path: `/googleEventSync/bookingsSyncStatus`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  healthcheck = {
    /**
     * No description
     *
     * @tags Healthcheck
     * @name CheckTheConnectionToPingpongServices
     * @request GET:/healthcheck/pingpong-service
     * @secure
     */
    checkTheConnectionToPingpongServices: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/healthcheck/pingpong-service`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healthcheck
     * @name CheckTheConnectionToNotificationServiceServices
     * @request GET:/healthcheck/notification-service
     * @secure
     */
    checkTheConnectionToNotificationServiceServices: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/healthcheck/notification-service`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healthcheck
     * @name AuthenticationCheckTheConnectionToPingpongServices
     * @request GET:/healthcheck/pingpong-service/authentication
     * @secure
     */
    authenticationCheckTheConnectionToPingpongServices: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/healthcheck/pingpong-service/authentication`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healthcheck
     * @name CheckTheConnectionToVideoServices
     * @request GET:/healthcheck/video-service
     * @secure
     */
    checkTheConnectionToVideoServices: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/healthcheck/video-service`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healthcheck
     * @name CheckTheConnectionToVideoServicesWithAuthentication
     * @request GET:/healthcheck/video-service/authentication
     * @secure
     */
    checkTheConnectionToVideoServicesWithAuthentication: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/healthcheck/video-service/authentication`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  googleForm = {
    /**
     * No description
     *
     * @tags ImportGoogleForm
     * @name ImportResponseFromGoogleForm
     * @request POST:/google-form/import/advisor-availability
     * @secure
     */
    importResponseFromGoogleForm: (
      data: ImportAvailabilityGoogleFormView,
      query?: {
        secret?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/google-form/import/advisor-availability`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  interests = {
    /**
     * No description
     *
     * @tags Interest
     * @name AdminRegisterInterestRequest
     * @request POST:/interests/admin-request
     * @secure
     */
    adminRegisterInterestRequest: (data: RegisterInterestView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/interests/admin-request`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Interest
     * @name RegisterOfInterest
     * @request POST:/interests
     * @secure
     */
    registerOfInterest: (data: RegisterInterestView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/interests`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Interest
     * @name GetAllInterestRequest
     * @request GET:/interests
     * @secure
     */
    getAllInterestRequest: (
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<InterestRequestResponsePaginationResult, ErrorResponse>({
        path: `/interests`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Interest
     * @name RegisterOfInterestForAnonymous
     * @request POST:/interests/v2
     * @secure
     */
    registerOfInterestForAnonymous: (data: PublicRegisterInterestView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/interests/v2`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Interest
     * @name ExportInterestRequests
     * @request GET:/interests/export
     * @secure
     */
    exportInterestRequests: (
      query?: {
        exporter?: ExporterType;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/interests/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  login = {
    /**
     * No description
     *
     * @tags Login
     * @name LoginSendOtpByBooking
     * @request POST:/login/bookings/{bookingId}/sendOtp
     * @secure
     */
    loginSendOtpByBooking: (bookingId: number, data: OtpBookingVerificationView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/login/bookings/${bookingId}/sendOtp`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name SendOtp
     * @request POST:/login/sendOtp
     * @secure
     */
    sendOtp: (data: OTPVerificationView, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/login/sendOtp`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name LoginWithBookingIdAndOtp
     * @request POST:/login/{bookingId}
     * @secure
     */
    loginWithBookingIdAndOtp: (bookingId: number, data: LoginWithBookingOTPView, params: RequestParams = {}) =>
      this.http.request<TokenResultView, ErrorResponse | string>({
        path: `/login/${bookingId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name Login
     * @request POST:/login
     * @secure
     */
    login: (data: LoginWithOTPView, params: RequestParams = {}) =>
      this.http.request<TokenResultView, ErrorResponse | string>({
        path: `/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name LoginByPassword
     * @request POST:/login/by-password
     * @secure
     */
    loginByPassword: (data: AdminLoginView, params: RequestParams = {}) =>
      this.http.request<TokenResultView, ErrorResponse | string>({
        path: `/login/by-password`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name GetToken
     * @request POST:/login/token
     * @secure
     */
    getToken: (data: LoginView, params: RequestParams = {}) =>
      this.http.request<TokenResultView, ErrorResponse | string>({
        path: `/login/token`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name OtpLogin
     * @request POST:/login/otp-login
     * @secure
     */
    otpLogin: (data: AdminLoginView, params: RequestParams = {}) =>
      this.http.request<OtpChallengeView, ErrorResponse | string>({
        path: `/login/otp-login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name OtpAnswer
     * @request POST:/login/otp-answer
     * @secure
     */
    otpAnswer: (data: OtpAnswerView, params: RequestParams = {}) =>
      this.http.request<TokenResultView, ErrorResponse | string>({
        path: `/login/otp-answer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name RefreshAccessToken
     * @request POST:/login/refresh-token
     * @secure
     */
    refreshAccessToken: (data: RefreshTokenView, params: RequestParams = {}) =>
      this.http.request<TokenResultView, ErrorResponse | string>({
        path: `/login/refresh-token`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name GetAnonymousOtpToken
     * @request GET:/login/anonymous-otp
     * @secure
     */
    getAnonymousOtpToken: (
      query: {
        email: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetAnonymousUserLoginResponse, ErrorResponse>({
        path: `/login/anonymous-otp`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Login
     * @name ValidateAnonymousOtpToken
     * @request POST:/login/anonymous-otp
     * @secure
     */
    validateAnonymousOtpToken: (data: AnonymousTokenValidationRequest, params: RequestParams = {}) =>
      this.http.request<IExternalUser, ErrorResponse>({
        path: `/login/anonymous-otp`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  scheduler = {
    /**
     * No description
     *
     * @tags Scheduler
     * @name SchedulerStartService
     * @request PUT:/scheduler/start
     * @secure
     */
    schedulerStartService: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/scheduler/start`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name SchedulerStopService
     * @request PUT:/scheduler/stop
     * @secure
     */
    schedulerStopService: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/scheduler/stop`,
        method: 'PUT',
        secure: true,
        ...params,
      }),
  };
  sensitiveData = {
    /**
     * No description
     *
     * @tags SensitiveData
     * @name GetSensitiveData
     * @request GET:/sensitive-data/review
     * @secure
     */
    getSensitiveData: (
      query: {
        otp?: string;
        salt?: string;
        token: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/sensitive-data/review`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SensitiveData
     * @name ReadSensitiveData
     * @request GET:/sensitive-data/read
     * @secure
     */
    readSensitiveData: (
      query: {
        token: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/sensitive-data/read`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SensitiveData
     * @name GetSensitiveDataOtp
     * @request GET:/sensitive-data/otp
     * @secure
     */
    getSensitiveDataOtp: (
      query: {
        email?: string;
        token: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ErrorResponse>({
        path: `/sensitive-data/otp`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  serverInfo = {
    /**
     * No description
     *
     * @tags ServerInfo
     * @name ServerInfoReloadConfigurations
     * @request GET:/serverInfo/configurations/reload
     * @secure
     */
    serverInfoReloadConfigurations: (params: RequestParams = {}) =>
      this.http.request<string, ErrorResponse>({
        path: `/serverInfo/configurations/reload`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name ServerInfoGetConfigs
     * @request GET:/serverInfo/configs
     * @secure
     */
    serverInfoGetConfigs: (params: RequestParams = {}) =>
      this.http.request<string, ErrorResponse>({
        path: `/serverInfo/configs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name ServerInfoGetEnvironmentValue
     * @request GET:/serverInfo/environment-configs/{environmentName}
     * @secure
     */
    serverInfoGetEnvironmentValue: (environmentName: string, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/serverInfo/environment-configs/${environmentName}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name ServerInfoGetAwsParametersStore
     * @request GET:/serverInfo/aws-parameters-store/{path}
     * @secure
     */
    serverInfoGetAwsParametersStore: (path: string, params: RequestParams = {}) =>
      this.http.request<GetParameterResponse, ErrorResponse | string>({
        path: `/serverInfo/aws-parameters-store/${path}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name ServerInfoGetAwsParametersStore2
     * @request GET:/serverInfo/aws-parameters-store
     * @originalName serverInfoGetAwsParametersStore
     * @duplicate
     * @secure
     */
    serverInfoGetAwsParametersStore2: (
      query?: {
        /** @format int32 */
        MaxResults?: number;
        NextToken?: string;
        ParameterFilters?: ParameterStringFilter[];
        Path?: string;
        Recursive?: boolean;
        WithDecryption?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetParametersByPathResponse, ErrorResponse | string>({
        path: `/serverInfo/aws-parameters-store`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name ServerInfoUpdateParameterStore
     * @request PUT:/serverInfo/aws-parameters-store
     * @secure
     */
    serverInfoUpdateParameterStore: (data: UpdateParameterStoreRequest, params: RequestParams = {}) =>
      this.http.request<PutParameterResponse, ErrorResponse | string>({
        path: `/serverInfo/aws-parameters-store`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name GetPublicApplicationSettings
     * @request GET:/serverInfo/application-settings/public
     * @secure
     */
    getPublicApplicationSettings: (params: RequestParams = {}) =>
      this.http.request<PublicApplicationSettingsView, ErrorResponse>({
        path: `/serverInfo/application-settings/public`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name GetApplicationSettings
     * @request GET:/serverInfo/application-settings
     * @secure
     */
    getApplicationSettings: (params: RequestParams = {}) =>
      this.http.request<ApplicationSettingsView, ErrorResponse>({
        path: `/serverInfo/application-settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerInfo
     * @name GetServerInfo
     * @request GET:/serverInfo
     * @secure
     */
    getServerInfo: (params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/serverInfo`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  shortLink = {
    /**
     * No description
     *
     * @tags ShortLink
     * @name ShortLinkCreateShortLinkUrlFromSensitiveData
     * @request POST:/short-link
     * @secure
     */
    shortLinkCreateShortLinkUrlFromSensitiveData: (data: CreateShortLinkRequest, params: RequestParams = {}) =>
      this.http.request<CreateShortLinkResponse, ErrorResponse>({
        path: `/short-link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortLink
     * @name GetFullUrl
     * @request GET:/short-link/{id}
     * @secure
     */
    getFullUrl: (id: string, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/short-link/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortLink
     * @name GetFullVideoLinkUrl
     * @request GET:/short-link/video-platform/{sessionLinkId}
     * @secure
     */
    getFullVideoLinkUrl: (sessionLinkId: string, params: RequestParams = {}) =>
      this.http.request<any, ErrorResponse>({
        path: `/short-link/video-platform/${sessionLinkId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags UserHistory
     * @name GetUserHistories
     * @request GET:/users/{userId}/histories
     * @secure
     */
    getUserHistories: (
      userId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserHistoryViewPaginationResult, ErrorResponse | string>({
        path: `/users/${userId}/histories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserHistory
     * @name GetUserBookingCalendarEventHistory
     * @request GET:/users/{userId}/histories/booking-calendar-events
     * @secure
     */
    getUserBookingCalendarEventHistory: (
      userId: number,
      query?: {
        /** @format int32 */
        pageIndex?: number;
        /** @format int32 */
        pageSize?: number;
        dynamicFilters?: string;
        dynamicSorts?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<BookingCalendarEventHistoryViewPaginationResult, ErrorResponse | string>({
        path: `/users/${userId}/histories/booking-calendar-events`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
